export default {
  login: {
    recaptcha: "Ce site est protégé par reCAPTCHA et la <a href='https://policies.google.com/privacy' target='_blank'>Politique de confidentialité</a> et les <a href='https://policies.google.com/terms' target='_blank'>Conditions d'utilisation</a> de Google s'appliquent.",
    title: 'Bienvenue',
    titleDescription: 'Connectez-vous pour accéder à votre espace client Ubiflow',
    username: "Nom d'utilisateur",
    usernamePlaceholder: 'Entrez un identifiant (Code client ou email)',
    password: 'Mot de passe',
    passwordPlaceholder: 'Entrez votre mot de passe',
    logIn: 'Connexion',
    passwordLost: 'Vous avez perdu votre mot de passe ?',
    passwordLostLink: 'Cliquez ici pour le réinitaliser',
    metaTitle: "Connexion à l'Espace Client Ubiflow",
    dialogSuspendedTitle: 'Espace Client suspendu',
    dialogSuspendedText: 'Un retard de paiement empêche l\'accès à votre Espace Client Ubiflow.<br />Vous pouvez prendre contact avec notre équipe ADV (<a href="mailto:adv@ubiflow.net">adv@ubiflow.net</a>) pour régulariser votre situation.<br /><br />A bientôt.',
    usernameSFC: 'Adresse mail',
    usernamePlaceholderSFC: 'Entrez email de connexion Se Faire Connaître',
    errorFetchFacebook: 'La diffusion Facebook n\'est pas paramétrée. Veuillez contacter le support.',
    SFCErrorTitle: 'Erreur de connexion',
    SFCErrorText: 'Une erreur a été rencontrée au moment de la connexion à votre espace client Ubiflow - Se Faire Connaître.<br><br> Veuillez nous excuser pour la gêne occasionnée.<br><br> Nous vous invitons à contacter notre service Relation Client soit par téléphone au 02.30.95.20.00  soit par email à l\'adresse : '
  },
  lostPassword: {
    title: 'Mot de passe perdu',
    titleDescription: 'Réinitialiser votre mot de passe',
    username: "Nom d'utilisateur ou adresse mail",
    usernamePlaceholder: 'Entrez un identifiant (Code client ou email)',
    confirm: 'OK',
    confirmationTitle: 'Mot de passe perdu',
    confirmationText: 'Un mail vient de vous être envoyé. Suivez les instructions indiquées sur celui-ci pour renouveler votre mot de passe et accéder à votre Espace Client.',
    backToLogin: 'Retourner au formulaire de connexion ?',
    backToLoginLink: 'Cliquez ici',
    metaTitle: 'Mot de passe perdu',
    confirmationTitleSFC: 'Modification mot de passe',
    confirmationText1SFC: 'Un mail vient de vous être envoyé sur votre adresse ',
    confirmationText2SFC: 'Suivez les instructions indiquées sur celui-ci pour renouveler votre mot de passe et accéder à votre espace client Ubiflow - Se Faire Connaître.'
  },
  changePassword: {
    title: 'Mot de passe perdu',
    titleDescription: 'Réinitialiser votre mot de passe',
    password1: 'Choisissez un mot de passe',
    password1Placeholder: 'Choisissez un mot de passe',
    password2: 'Confirmez votre mot de passe',
    password2Placeholder: 'Confirmez votre mot de passe',
    confirm: 'OK',
    backToLogin: 'Retourner au formulaire de connexion ?',
    backToLoginLink: 'Cliquez ici',
    metaTitle: 'Mot de passe perdu'
  },
  activateProduct: {
    pageTitle: 'Activation du produit',
    title: 'Bienvenue',
    titleDescription: 'Vous pouvez dès à présent renseigner votre code pour activer votre formulaire de qualification.',
    titleDescriptionResponse: 'Vous avez activer votre formulaire. Vous pouvez désormais fermer cette page',
    productActivateResponse: 'Vous avez activer votre formulaire.',
    labelCode: 'Code d\'activation',
    labelButton: 'Activer',
    codeRequired: 'Le code est obligtaoire'
  },
  forbidden403: {
    title: 'Accès interdit',
    text: "Vous n'avez pas accès à cette page.",
    link: "Retour à l'accueil",
    metaTitle: 'Erreur 403 - Accès interdit'
  },
  notFound404: {
    title: 'Page introuvable',
    text: "La page que vous souhaitez atteindre n'existe pas ou a été déplacée.",
    link: "Retour à l'accueil",
    metaTitle: 'Erreur 404 - Page non trouvée'
  },
  unauthorized401: {
    title: 'Accès interdit',
    text: 'Vous devez être authentifié pour accéder à cette page.',
    link: 'Connexion',
    metaTitle: 'Erreur 401 - Accès interdit'
  },
  serverError500: {
    message: 'Une erreur a été rencontrée lors du chargement des données.'
  },
  layouts: {
    notificationAlerts: 'Alertes',
    notifications: 'Notifications',
    noNotification: 'Aucune notification actuellement',
    createAd: 'Créer une annonce',
    create_program: 'Créer un programme',
    contactUs: 'Nous contacter',
    callbackFromAnAdvisor: 'Être recontacté par un conseiller',
    portailClient: 'Mon espace factures',
    logOut: 'Déconnexion',
    goBackOldCustomerSpace: "Revenir à l'ancien espace",
    contactBook: 'Mes utilisateurs',
    dashboard: 'Tableau de bord',
    ads: 'Annonces',
    selectionVo: 'Sélection VO',
    programs: 'Programmes',
    home: 'Accueil',
    portals: 'Portails',
    profile: 'Profil',
    diffusion: 'Diffusions',
    contactManager: 'Contact Manager',
    localPresence: 'Présence locale',
    socialManagment: 'Social Manager',
    report: 'Rapport',
    adLifetime: 'Délai d\'écoulement',
    localReference: 'Référencement local',
    postManagement: 'Gestion des posts',
    socialReviews: 'Avis clients',
    planningCalendar: 'Calendrier de planification',
    sfc: 'Se Faire Connaître',
    offeredBy: 'Espace Client proposé par',
    ubiflow: 'Ubiflow',
    legalNotice: 'Mentions légales',
    conditionsOfSale: 'CGV',
    conditionsOfSaleOfDiffusion: 'CGV Diffusion',
    conditionsOfSaleOfContactManager: 'CGV Contact Manager',
    conditionsOfSaleOfSocialManager: 'CGV Social Manager',
    titleTemplate: 'Espace Client Ubiflow',
    personalInformation: 'Mes paramètres',
    help: 'Aide',
    changeUser: "Changer d'utilisateur",
    warning: 'Attention',
    dactivateAdBlock: "Il semblerait qu'un bloqueur de publicité empêche l'affichage de vos données. Merci de bien vouloir le désactiver.",
    exportSuccess: 'L\'export de vos données est en cours de création, vous recevrez un mail dès qu\'il sera consultable.',
    exportErrorAccess: "Vous n'avez pas accès à cette fonctionnalité",
    exportWarningNoEmail: "L'export sera généré, mais vous ne recevrez pas de mail. Aucune adresse email n'est associée à votre compte. Veuillez vous rapprocher de notre relation client.",
    exports: 'Mes Exports',
    quotas: 'Gestion de mes quotas',
    sponsorshipImmo: 'Parrainez un professionnel de l\'immobilier et recevez 50€ en carte cadeau ! Cliquez pour en savoir plus !',
    sponsorshipVo: 'Parrainez un professionnel de l\'automobile et recevez 50€ en carte cadeau ! Cliquez pour en savoir plus !',
    socialNetworks: 'Réseaux sociaux',
    contactsVisitesTitle: 'Visites par annonces',
    portalsSocialManagment: 'Diffusion réseaux sociaux',
    statistics: 'Statistiques',
    annoncesCommerciaux: 'Annonces par commerciaux'
  },
  popup: {
    oldCustomerArea: 'Fermeture ancien Espace Client'
  },
  routes: {
    homeTitle: 'Accueil',
    myAccountTitle: 'Mes paramètres',
    localPresenceTitle: 'Référencement local',
    ubiflowProducts: 'Produits Ubiflow',
    contactUsTitle: 'Nous contacter',
    tutorialsVideosTitle: 'Aide',
    myWebsiteTitle: 'Mon site web',
    conditionsOfSaleTitle: 'Conditions générales de vente',
    conditionsOfSaleOfDiffusionTitle: 'Conditions générales de vente diffusion',
    conditionsOfSaleOfContactManagerTitle: 'Conditions générales de vente contact Manager',
    globalIntegrationReport: "Rapport d'intégration global",
    globalDiffusionReport: 'Rapport de diffusion global',
    adLifetimeDetail: 'Détail du délai d\'écoulement',
    adsTitle: 'Annonces',
    adsListTitle: 'Liste des annonces',
    createAdTitle: 'Créer une annonce',
    createAdModelTitle: 'Créer un modèle',
    adDetailsTitle: "Détails d'une annonce",
    editAdTitle: "Édition d'une annonce",
    adsSelectionTitle: 'Sélection des annonces',
    diffusionSelectionTitle: 'Sélection des diffusions',
    presenceReportTitle: 'Rapport de présence',
    contactManagerTitle: 'Contact Manager',
    contactsSynthesisDiffusionTitle: 'Synthèse des contacts générés par mes diffusions',
    contactsGeneratedByPortalsTitle: 'Contacts générés par mes portails',
    contactsDetailsPerPortalTitle: 'Détail des contacts par portail',
    contactsGeneratedByAdsTitle: 'Contacts générés par mes annonces',
    contactsDetailsPerAdTitle: 'Détail des contacts par annonce',
    contactsSynthesisTitle: 'Synthèse des contacts',
    contactsStatsTitle: 'Statistiques',
    contactsGeneratedTitle: 'Contacts générés',
    demandeRapprochementDetailsPerPortalTitle: 'Demandes de rapprochement',
    diffusionsListTitle: 'Liste des diffusions',
    diffusionSelogerTitle: 'Groupe Seloger',
    diffusionReportTitle: 'Rapport de diffusion',
    diffusionsPerAdTitle: 'Diffusions par annonce',
    tutoralsVideosTitle: 'Tutoriels vidéos',
    myAccountsTitle: 'Liste des utilisateurs',
    comptes: 'Comptes',
    diffusion: 'Diffusion',
    program: 'Programmes',
    lot: 'Lots',
    exports: 'Mes exports',
    quotas: 'Gestion des quotas',
    contentLibrary: 'Ma bibliothèque de contenus',
    PrivateNote: "Note privée de l'annonce",
    managePosts: 'Gérer mes posts',
    editBienVendu: 'Gérer le bien vendu',
    newBienVendu: 'Création d\'un bien vendu',
    socialNetworks: 'Mes réseaux sociaux',
    contactsVisitesTitle: 'Visites par annonce',
    ubiflowProductQualiforma: 'Formulaire de qualification',
    portalsSocialManagmentTitle: 'Diffusion réseaux sociaux',
    optimizeBroadcastTitle: 'Optimisation de ma diffusion d\'annonces',
    statistics: 'Statistiques',
    modelsEditoLibrary: 'Bibliothèque de modèles de posts éditoriaux',
    socialPosts: {
      models: {
        create: 'Créer un modèle de post éditorial',
        edit: 'Editer un modèle',
        use: 'Utiliser un modèle',
        modelSummary: 'Résumé du modèle',
        for: 'Pour',
        actions: 'Actions'
      }
    },
    contactsProgramsTitle: 'Contacts par programmes'
  },
  contact: { // contact form
    mainText: "Vous avez une question sur l'utilisation de votre Espace Client, " +
               "besoin d'un <strong>renseignement sur un produit</strong> ou encore vous souhaitez partager " +
               "avec notre équipe un <strong>retour d'expérience</strong> et nous soumettre des " +
               "<strong>idées d'évolution</strong>, contactez-nous en remplissant le formulaire ci-dessous.",
    object: 'Objet de votre message *',
    objectOption1: 'Poser une question sur un produit',
    objectOption2: 'Soumettre un nouveau portail',
    objectOption3: "Poser une question sur l'utilisation de votre Espace Client",
    objectOption4: 'Proposer une évolution de l\'Espace Client',
    objectOption5: 'Autres',
    objectOption6: 'Demander assistance',
    writeMessage: 'Rédigez votre message *',
    writeMessagePlaceholder: 'Afin de nous aider à mieux répondre, si votre question concerne une annonce ou votre diffusion, ' +
                             'indiquez nous la référence de votre annonce, le nom du portail concerné, etc.',
    name: 'Votre nom et prénom',
    email: 'Votre mail *',
    phone: 'Votre numéro de téléphone',
    sendEmailCopy: 'Envoyer une copie sur ma propre adresse e-mail',
    send: 'Envoyer ma demande',
    ruleObjectRequired: "L'objet est obligatoire",
    ruleMessageRequired: 'Le message est obligatoire',
    ruleEmailRequired: 'Le mail est obligatoire',
    rulePhoneNumber: 'Accepte uniquement des chiffres',
    messageEmailSent: 'Votre email a bien été envoyé',
    messageEmailError: 'Une erreur a été rencontrée',
    messageLeadsQualification: 'Optimisez automatiquement la qualification de vos leads grâce à notre nouvelle option gratuite. Activez-la dès maintenant en cliquant'
  },
  contacts: { // Contact Manager
    noActivated: {
      title: 'Contact manager',
      title1: "Cette fonctionnalité n'est pas activée dans votre abonnement",
      text1: "Besoin de maîtriser et d'accélérer la vente vers vos futurs clients ?<br />" +
             'Vous souhaitez suivre de près tous les contacts issus des portails ?',
      title2: 'Décompte et statistiques',
      text2: 'Tous les contacts issus des portails de votre multidiffusion, même des portails ' +
             'sur lesquels vous diffusez sans Ubiflow, sont comptabilisés jour après jour. ' +
             'Un tableau de synthèse vous est envoyé toutes les semaines.',
      title3: 'Archivage de vos contacts',
      text3: 'Dans cette rubrique « Contacts générés par mes diffusions », ' +
             "vous avez accès à la liste complète et à l'historique de tous vos prospects. " +
             'Une mise en page pratique, un champ de recherche, un tri par date, la possibilité ' +
             "d'exporter la liste de vos contacts... Autant d'outils pour vous permettre un suivi " +
             'dans le temps et une exploitation par votre équipe.',
      title4: 'Le bon contact à la bonne personne',
      text4: "Les contacts sont envoyés directement au commercial dédié, si la référence de l'annonce permet de le reconnaître.",
      title5: "Simplification d'une demande",
      text5: "Les mails des portails sont reformatés en un mail uniformisé, où l'information qui vous intéresse " +
             "est visible en un clin d'oeil. Vous ne vous perdez plus dans le flot de mails différents pour " +
             'retrouver vos demandes de contact.',
      discover: 'Découvrir le produit',
      beContacted: 'Intéressé par ce produit ? Être contacté par un conseiller commercial.',
      emailSubject: 'Client {{advertiser}} : Contact Manager - Demande de contact',
      emailContent: 'Le client {{advertiser}} ({{companyName}}) a fait une demande de contact sur le nouvel ' +
                     'espace client pour la solution "Contact Manager". Vous pouvez le recontacter ' +
                     'via {{email}} ou au numéro {{phoneNumber}}',
      dialogMessage: 'Vous souhaitez des informations sur notre produit Contact Manager. Notre équipe va prendre contact avec vous dans les meilleurs délais'
    },
    generatedByPortals: 'Contacts générés par mes portails',
    generatedByAds: 'Contacts générés par mes annonces',
    accessToCockpit: 'Accéder à Cockpit',
    accumulatedIndicators: "Indicateurs d'activité cumulés sur la période en cours",
    exportEmailContacts: 'Exporter les contacts mail',
    exportPhoneContacts: 'Exporter les contacts téléphoniques',
    exportResults: 'Exporter les résultats',
    generatedContactsTotal: 'contact généré (total)',
    generatedContactsTotal_plural: 'contacts générés (total)',
    tooltipTotal: 'Sur les annonces diffusées et non diffusées',
    generatedContactsActiveAds: 'contact généré (annonces actives)',
    generatedContactsActiveAds_plural: 'contacts générés (annonces actives)',
    tooltipActiveAds: 'Contacts générés sur les annonces en cours de diffusion',
    contactsByEmail: 'Contacts mails',
    contactsByPhone: 'Contacts téléphoniques',
    adsSent: 'Annonce diffusée',
    adsSent_plural: 'Annonces diffusées',
    activePortals: 'Portail actif',
    activePortals_plural: 'Portails actifs',
    activityDistributionTitle: "Répartition d'activité sur la période en cours sur les annonces en cours de diffusion",
    activityDistributionEmailContacts: 'Répartition contacts mail (annonces diffusées)',
    activityDistributionNoData: 'Pas de données pour cette période',
    activityDistributionOffers: 'Offres',
    activityDistributionProperties: 'Biens',
    activityDistributionPortals: 'Portails',
    performancePortailsAnnonces: 'Performance des portails et des annonces (7 derniers jours)',
    contactDetailsTitle: 'Détails des contacts reçus',
    activityDistributionTitleVO: 'Répartition des contacts générés sur la période en cours sur les annonces en cours de diffusion',
    contactDetailsLastMonths: '12 derniers mois',
    contactDetailsLastDays: '30 derniers jours',
    listGeneratedContactsTotal: 'Total des contacts mails générés',
    listDemandesRapprochementTotal: 'Total des demandes de rapprochement',
    listGeneratedProspectsTotal: 'Total prospects',
    listGeneratedCallContactsTotal: 'Total des contacts téléphoniques',
    listGeneratedEmailContactsTotal: 'Total des contacts mail',
    listTooltipTotal: 'Sur les annonces diffusées et non diffusées',
    listGeneratedContactsMail: 'Contacts mail générés',
    listTooltipMail: 'Contacts mail générés sur les annonces en cours de diffusion',
    listGeneratedContactsAds: 'Contacts générés sur les annonces actives',
    contactUnique: 'Contacts uniques sur les annonces actives',
    contactUniquePortals: 'Contacts uniques générés par mail',
    contactUniqueTooltips: 'Contacts uniques générés sur les mails',
    listAdsSentContacts: 'Contacts générés (annonces diffusées)',
    listAdsSent: "Total d'annonces diffusées",
    listActivePortals: 'Total portails actifs',
    listPortalsEquippedWithCM: 'Portails équipés de Contact Manager',
    listGraphNoData: 'Pas de données pour cette période',
    listGraphDistributionByMail: 'Répartition des contacts par mail',
    listGraphAdsSent: 'annonces diffusées',
    listGraphAdsSentDistribution: 'Répartition (annonces diffusées)',
    listTableNoData: 'Pas de données pour cette période',
    listTablePropertyTypes: 'Types de biens',
    listTableOfferTypes: "Types d'offres",
    listColumnLogo: 'Logo',
    listColumnPortal: 'Nom portail',
    listColumnBusinessModel: 'Modèle économique',
    listColumnContactsTotal: 'Contacts totaux',
    listColumnContactsMail: 'Contacts mail',
    listColumnContactsTel: 'Contacts tel',
    listColumnAds: 'Annonces',
    listColumnAdsNoActiveDiffusion: 'Pas de diffusion active',
    listColumnTooltipAdNoSent: 'Cette annonce n\'est pas ou plus diffusée',
    listColumnAd: 'Annonce',
    listColumnReference: 'Référence',
    listColumnActivePortals: 'Portails actifs',
    listColumnContacts: 'Contacts',
    listColumnDate: 'Date',
    listColumnDateAndHour: 'Date et heure',
    listColumnAdReference: 'Référence annonce',
    listColumnCivilityLastnameFirstname: 'Civilité, nom, prénom',
    listColumnEmail: 'Mail',
    listColumnScoring: 'Scoring',
    listColumnPhoneNumber: 'Téléphone',
    listColumnQualification: 'Qualification',
    qualificationStateQualified: 'Qualifié',
    qualificationStateInProgress: 'En cours',
    qualificationStateUnknown: 'Nouveau',
    listColumnFormLink: 'Détail du formulaire',
    listColumnConversationDetail: 'Détail de la conversation',
    whatsappConversationLink: 'Voir la conversation',
    whatsappUnreachable: 'Non joignable sur Whatsapp',
    whatsappConversationImpossible: 'Conversation impossible',
    whatsappConversationTitle: 'Détail de la conversation WhatsApp',
    whatsappConversationLead: 'Lead',
    whatsappConversationProperty: 'Bien',
    whatsappConversationQualifiedData: 'Données qualifiées',
    whatsappConversationTranscript: 'Transcription intégrale',
    whatsappConversationLoading: 'Chargement…',
    whatsappConversationLoadError: 'Impossible de charger la conversation.',
    whatsappConversationClose: 'Fermer',
    whatsappThreadStateCompleted: 'Terminée',
    whatsappThreadStateUnanswered: 'Non répondue',
    whatsappThreadStateAbandoned: 'Abandonnée',
    whatsappThreadStateInProgress: 'En cours',
    whatsappThreadStatePending: 'En attente',
    whatsappThreadStateOperatorRequested: 'Opérateur demandé',
    whatsappThreadStateError: 'Erreur',
    whatsappThreadStateUnknown: 'Inconnu',
    whatsappConversationNoThread: 'Aucune conversation WhatsApp à afficher pour ce contact.',
    whatsappMockQualifiedBadge: 'Qualifié',
    whatsappMockFieldBudget: 'Budget',
    whatsappMockFieldLocation: 'Localisation',
    whatsappMockFieldPropertyType: 'Type de bien',
    whatsappMockFieldDeadline: 'Échéance',
    whatsappMockFieldOwner: 'Déjà propriétaire',
    whatsappMockFieldEstimate: 'Besoin d\'une estimation',
    whatsappMockValueBudget: '850 000 €',
    whatsappMockValueLocation: 'Rennes',
    whatsappMockValuePropertyType: 'Maison T5',
    whatsappMockValueDeadline: 'Moins de 3 mois',
    whatsappMockValueYes: 'Oui',
    whatsappMockValueNo: 'Non',
    whatsappTranscriptFieldContactFullName: 'Nom et prénom',
    whatsappTranscriptFieldProjectType: 'Type de projet',
    whatsappTranscriptFieldSearchLocation: 'Zone de recherche',
    whatsappTranscriptFieldPropertyType: 'Type de bien recherché',
    whatsappTranscriptFieldBudget: 'Budget max (frais de notaire inclus)',
    whatsappTranscriptFieldBudgetRental: 'Budget max charges comprises',
    whatsappTranscriptFieldCriteria: 'Critères (souhaités ou non négociables)',
    whatsappTranscriptFieldPreviousVisitsFeedback: 'Retours sur visites déjà effectuées',
    whatsappTranscriptFieldProjectDeadline: 'Échéance du projet',
    whatsappTranscriptFieldFinancingStatus: 'Avancement du financement',
    whatsappTranscriptFieldIsCurrentOwner: 'Propriétaire actuellement',
    whatsappTranscriptFieldNeedsPropertyEstimation: 'Estimation du bien (vente)',
    whatsappTranscriptFieldContactAvailability: 'Disponibilité pour être contacté',
    whatsappTranscriptFieldOccupantCount: "Nombre d'occupants",
    whatsappTranscriptFieldArea: 'Surface souhaitée',
    whatsappTranscriptFieldRoomCount: 'Nombre de pièces',
    whatsappTranscriptFieldTenantStatus: 'Situation locataire / préavis',
    whatsappTranscriptFieldEmploymentStatus: 'Situation professionnelle',
    whatsappTranscriptFieldMonthlyNetIncome: 'Revenu net mensuel du foyer',
    whatsappTranscriptFieldHasGuarantor: 'Garant',
    listColumnCallStatus: "Statut de l'appel",
    listColumnCallDuration: "Durée de l'appel",
    listColumnDemandesRapprochement: 'Demandes de rapprochement',
    listTabMailtracking: 'Mail tracking',
    listTabMailtrackingPostalCode: 'Code postal',
    listTabMailtrackingCity: 'Ville',
    listTabMailtrackingAdAddress: 'Adresse annonce',
    listTabMailtrackingNoInformation: 'Non renseigné',
    listTabCalltracking: 'Call tracking',
    listTabCalltrackingCallAnswered: 'Appel pris',
    listTabCalltrackingCallMissed: 'Appel manqué',
    callStatus: 'Statut de l\'appel',
    callStatusAnswered: 'Appel pris',
    callStatusMissed: 'Appel manqué',
    qualificationForm: 'Formulaire de qualification',
    hasFilledQualificationForm: 'A rempli le formulaire',
    hasNotFilledQualificationForm: 'N\'a pas rempli le formulaire',
    listUniqueAds: 'Annonces uniques',
    listUniqueContacts: 'Contacts uniques',
    listUniqueContactsPortals: 'Contacts uniques mails',
    listProgramme: 'Programme',
    listLot: 'Lot',
    typeObjetPromoteur: 'Type d\'annonce',
    toolTipAdNotDiffused: 'Cette annonce n\'est plus diffusée',
    generalInformation: 'Informations générales',
    postReference: 'Référence',
    postPrice: 'Prix',
    postLocation: 'Localisation',
    postEmptyField: 'Ce champ est vide',
    buttonContactsByPortal: 'Contacts par portail',
    buttonContactsByAd: 'Contacts par annonce',
    buttonContactsAll: 'Tous les contacts',
    buttonContactsVisites: 'Visites par annonce',
    filenameExportContactsPortals: 'contacts_portails',
    filenameExportContactsAds: 'contacts_annonces',
    filenameExportContactsPerPortal: 'contacts_par_portail',
    filenameExportContactsPerAd: 'contacts_annonce',
    filenameExportContactsCalls: 'contacts_calltracking',
    filenameExportContacts: 'contacts_mailtracking',
    contactGenere: 'Contacts générés',
    listTooltipUniqueAds: 'Nombre d\'annonces uniques concernées par des contacts',
    typeOffre: 'Type d\'offre',
    visites: {
      columnDateVisite: 'Date et heure de la visite',
      columnAdReference: 'Référence',
      columnJaugeVisite: 'Nb d\'inscrits / Nb de visiteurs max',
      columnNbAttente: 'Nb de candidats en attente',
      columnListeCandidatsExport: 'Liste des candidats',
      columnAdStatut: 'Statut annonce',
      searchByReference: 'Chercher par référence',
      adActive: 'Active',
      adInactive: 'Inactive'
    },
    buttonContactsPrograms: 'Contacts par programmes'
  },
  quotas: {
    validerQuotas: 'VALIDER CETTE RÉPARTITION DES QUOTAS',
    repartitionQuotas: 'Répartir les quotas équitablement',
    total: 'Total',
    portails: 'Portails',
    succesUpdate: 'La modification de vos quotas a été appliquée.',
    quotaPerso: 'Quota personnel',
    txtPresentationQuota: 'Depuis cette page, vous avez la possibilité de gérer la répartition de vos quotas de diffusion par utilisateur. Vous pouvez l\'éditer manuellement ou opter pour une répartition équitable.',
    txtAucunQuota: "Aucune donnée ne peut être affichée, soit parce que toutes vos diffusions sont en statut \"illimitée\" ou qu'aucun utilisateur ne dispose d'un stock d'annonces",
    max: 'Quota max',
    tooltipsTotalQuotas: 'Total annonces diffusées / total quotas attribués'
  },
  website: {
    title: 'Site Web',
    functionalityNoActivated: "Cette fonctionnalité n'est pas activée dans votre abonnement.",
    contactUs: 'Nous contacter'
  },
  presenceLocale: {
    title: 'Solution Se Faire Connaître',
    text1: 'Faites rayonner votre entreprise sur le local et allez plus loin dans votre relation avec vos futurs clients grâce à notre offre de ',
    keywordText1: 'référencement local.',
    text2Bold: '1 - Améliorez votre visibilité locale sur Internet.',
    text2: 'Notre solution permet de diffuser automatiquement, et sans aucun effort de votre part, les informations de votre(vos) point(s) de vente sur les 16 médias de notre catalogue (Google, Maps, Facebook, Waze, Foursquare, ...)',
    text3Bold: '2 - Mettez en avant votre activité',
    text3: 'Grâce à notre fonctionnalité, gérez depuis 1 seul et même endroit vos posts et diffusez les sur les 3 plus grands médias: \n Google, Facebook et Instagram.',
    keywordText3: 'L\'Intelligence Artificielle',
    suiteText3: 's\'en mêle et vous aide à produire du contenu varié et de qualité.',
    text4Bold: '3 - Gardez le lien avec votre communauté et gérez votre e-reputation',
    text4: 'En plus de tenir informé vos utilisateurs et potentiels clients, maintenez un lien permanent avec eux, soyez alertés dès lors qu\'ils vous laissent un commentaire sur Google et Facebook. L\'Intelligence Artificelle vous accompagne pour répondre au plus juste et de manière personnalisée.',
    text5Bold: '4 - Organisez et anticipez votre communication',
    text5: 'Un outil de planification vous permet de fluidifier votre présence sur les médias et de gagner un temps précieux.',
    text6: 'C\'est donc le moment de coller aux usages des clients qui vous cherchent sur Internet et les réseaux sociaux. \n',
    text7: 'Bref, avec notre solution de référencement local, ',
    cashPhrase: 'on vous cherche, on vous trouve !',
    beContacted: 'Intéressé par ce produit ? Être contacté par un conseiller commercial.',
    alreadyClient: "Vous disposez déjà d'un compte ? Connectez-vous à votre espace.",
    emailSubject: 'Client {{advertiser}} : Se faire connaitre - Demande de contact',
    emailContent: 'Le client {{advertiser}} ({{companyName}}) a fait une demande de contact sur le ' +
                   'nouvel espace client pour la solution "Se faire connaitre". Vous pouvez le recontacter ' +
                   'via {{email}} ou au numéro {{phoneNumber}}',
    dialogMessage: 'Vous souhaitez des informations sur notre produit Se Faire Connaître. Notre équipe va prendre contact avec vous dans les meilleurs délais',
    txtAccesTeteDeReseau: "<p class=\"text-justify\">Votre réseau dispose d'un abonnement à la solution Se Faire Connaître.</p>" +
        "<p class=\"text-justify\">Cependant la gestion de cet abonnement et l'accès à l'interface Se Faire Connaître " +
        'sont limités à votre tête de réseau. Votre point de vente ne peut donc pas y accèder.</p>' +
        '<p class="text-justify">En cas de question, veuillez contacter directement votre tête de réseau.</p>'
  },
  socialNetworkPosts: {
    title: 'Gestions des posts',
    text1: 'Grâce à notre offre de diffusion sur les réseaux sociaux et Google My business : \n',
    text2: 'Optimisez les contenus sur les premiers réseaux sociaux et le premier média,',
    text3: 'Améliorez le référencement naturel de votre site et les visites dans vos points de vente,',
    text4: 'Développez votre communauté, des nouveaux points d\'interaction et ainsi de nouvelles opportunités de business,',
    text5: 'Diffusez plus largement votre portefeuille d\'annonces,',
    text6: 'Et valorisez vos petites annonces dans le respect des bonnes pratiques appréciées de chacun des supports.',
    text7: 'De quels médias s\'agit-il ?',
    beContacted: 'Vous êtes intéressé et souhaitez en savoir plus ? Être contacté par votre commercial.',
    emailSubject: 'Client {{advertiser}} : Réseaux sociaux - Nouvelle demande de contact depuis l\'Espace client',
    emailContent: 'Le client {{advertiser}} ({{companyName}}) a fait une demande depuis son espace client. ' +
                   'Il souhaite plus de renseignements sur notre offre de réseaux sociaux et demande à être recontacté par le commercial qui suit son dossier.  ',
    dialogMessage: 'Vous souhaitez des informations sur notre solution de gestion des posts ? Notre équipe va prendre contact avec vous dans les meilleurs délais',
    alreadyClient: 'Déjà équipé de la solution ? Accéder à la page de gestion de vos annonces.',
    operationDisabledFlux: 'Opération non disponible car le post a été créé par votre logiciel',
    messageDisabledCheckbox: 'Vous devez renseigner le contenu du post avant de sélectionner vos réseaux sociaux'
  },
  validator: {
    usernameRequired: "Le nom d'utilisateur est obligatoire",
    passwordRequired: 'Le mot de passe est obligatoire',
    passwordConfirmationRequired: 'La confirmation du mot de passe est obligatoire',
    passwordMustBeEquals: 'Les mots de passes doivent être les mêmes',
    plate: {
      letterIandOnotAllowed: 'Les lettres I et O ne sont pas admises.',
      invalid: "L'immatriculation n'est pas valide.",
      sivFormat: "Après 2009, l'immatriculation doit être au format SIV (AA-999-BB)",
      sivOrFniFormat: "L'immatriculation doit être au format FNI (1234 AB 35) ou SIV (AA-999-BB)",
      alreadyExists: "L'immatriculation saisie existe déjà dans votre liste d'annonces"
    },
    alertMandatoryFields: 'Veuillez renseigner tous les champs nécéssaires',
    offerTypeRequired: "Le type d'offre est obligatoire",
    propertyTypeRequired: 'Le type de bien est obligatoire',
    referenceRequired: 'La référence est obligatoire',
    referenceMustBeWithoutAccentAndSpecialCharacter: "La référence n'est pas valide. Les accents et caractères spéciaux ne sont pas acceptés.",
    titleRequired: 'Le titre est obligatoire',
    priceRequired: 'Le prix est obligatoire',
    priceMustBeNumber: 'Le prix doit être un nombre',
    monthlyRentRequired: 'Le loyer mensuel est obligatoire',
    monthlyRentMustBeNumber: 'Le loyer doit être un nombre',
    showPriceRequired: 'Indiquez si vous souhaitez afficher le prix',
    textRequired: "La description de l'annonce est obligatoire",
    textAtLeast: 'Un minimum de {{ number }} caractères est requis',
    realPostalCodeRequired: 'Le code postal réel est obligatoire',
    realCityRequired: 'La ville réelle est obligatoire',
    postalCodeRequired: 'Le code postal est obligatoire',
    cityToShowRequired: 'La ville est obligatoire',
    mustBeNumber: 'Ce champ doit être un nombre',
    mustBeNumericValue: 'Ce champ doit être une valeur numérique',
    serialNumberAtLeast: 'Le numéro de série doit contenir {{ number }} caractères',
    vin: {
      invalid: "Le numéro VIN n'est pas valide.",
      checkFailed: 'Impossible de vérifier le numéro VIN. Veuillez réessayer.'
    },
    brandRequired: 'La marque est obligatoire',
    modelRequired: 'Le modèle est obligatoire',
    yearRequired: 'Le millésime est obligatoire',
    versionRequired: 'La version est obligatoire',
    mileageRequired: 'Le kilométrage est obligatoire',
    energyRequired: "L'énergie est obligatoire",
    offerTitleMax: '{{ number }} cacarctères maximum',
    corporateNameRequired: 'La raison sociale est obligatoire',
    wrongFormat: 'Mauvais format',
    httpOrHttps: 'Le champ doit commencer par http:// ou https://',
    referenceAlreadyExists: 'La référence de votre annonce existe déjà',
    enterReference: 'Veuillez saisir une référence',
    validEmail: 'Ce champ doit-être un email valide',
    addDelete: 'Vos annonces ont bien été supprimées',
    addDuplicate: 'Votre annonce a bien été dupliquée',
    addUpdate: 'Votre annonce a bien été mise à jour',
    addMerge: 'Votre annonce a bien été créée',
    isRequired: 'Ce champ est obligatoire',
    errorReferenceExceed: 'Votre référence fait plus de 20 caractères, la diffusion de votre annonce risque d\'être bloquée auprès de certains portails partenaires.',
    confirmReferenceExceedTitle: 'Référence trop longue',
    confirmReferenceExceedQuestion: 'Souhaitez-vous l\'enregistrer malgré tout ?',
    confirmReferenceExceedNote: 'NB : une fois votre annonce enregistrée, la référence ne pourra pas être modifiée.'
  },
  error: {
    unknown: 'Une erreur inconnue est apparue.',
    found: 'Une erreur a été rencontrée',
    gif: "Le format GIF n'est pas accepté",
    formatImage: "Le format {{ format }} n'est pas accepté",
    formatImageNotAllowed: "Format d'image non autorisé. Formats acceptés: JPG, PNG, WebP, HEIC, AVIF",
    limitExceeded: 'Vous avez dépassé la limite d\'envoi de {{ limitImages }}',
    fileTooLarge: 'Le fichier est trop volumineux. Taille maximale autorisée : {{ maxSize }}',
    heicConversionFailed: 'Impossible de convertir le fichier HEIC {{ filename }}. Veuillez utiliser un autre format.'
  },
  success: {
    heicWillBeConverted: 'Le fichier HEIC {{ filename }} sera converti en JPEG.'
  },
  components: {
    lists: {
      resultsPerPage: 'Résultats par page : ',
      sortByPlaceholder: 'Trier par...',
      sortByLabel: 'Tri par {{ label }}',
      resultsFromTo: 'Résultats {{ from }} à {{ to }} sur {{ total }}',
      noResult: 'Aucun résultat',
      loading: 'Chargement en cours...',
      eraseSelection: 'Effacer la sélection',
      selectAll: 'Tout sélectionner',
      columnThumbnails: 'Photos',
      valide: 'Validée',
      diffusee: 'Diffusée',
      errorOnLoading: 'Une erreur est survenue au chargement de cette page'
    },
    card: {
      activated: 'Activé',
      deactivated: 'Désactivé',
      postFlux: 'Cette annonce doit être supprimée dans votre logiciel et non depuis votre Espace Client Ubiflow',
      draft: 'Brouillon',
      model: 'MODÈLE',
      createdOn: 'Créée le',
      updatedOn: 'Modifiée le',
      checkboxDisabledOtherUser: 'Vous ne pouvez pas sélectionner cette annonce car elle a été créée par un autre utilisateur.'
    },
    searchContainer: {
      hideFilters: 'Masquer les filtres',
      showFilters: 'Afficher les filtres',
      search: 'Rechercher',
      orFilterBy: 'ou filtrer par :',
      advancedSearch: 'Recherche avancée'
    },
    facebook: {
      label: 'Connexion Facebook'
    },

    //  Nouvelles traductions pour les formulaires de recherche
    searchForm: {
      mainSection: 'Recherche principale',
      mainSectionDescription: 'Critères de recherche principaux',
      advancedSection: 'Recherche avancée',
      advancedSectionDescription: 'Critères de recherche avancés'
    },

    //  Nouvelles traductions pour les champs de recherche
    searchField: {
      text: 'Champ texte',
      select: 'Liste déroulante',
      multiselect: 'Sélection multiple',
      radio: 'Boutons radio',
      daterange: 'Plage de dates',
      range: 'Plage numérique',
      cascader: 'Menu en cascade',
      placeholder: 'Texte d\'aide',
      clearable: 'Effaçable',
      filterable: 'Filtrable',
      multiple: 'Multiple',
      min: 'Minimum',
      max: 'Maximum',
      suffix: 'Suffixe',
      loadingData: 'Chargement des données...'
    },

    //  Nouvelles traductions pour le formulaire configurable
    configurableSearchForm: {
      loadingConfig: 'Chargement de la configuration...',
      configError: 'Erreur de chargement de la configuration'
    }
  },
  posts: {
    list: {
      assignUser: 'Assigner à un utilisateur',
      pageTitleLots: 'Liste des lots',
      pageTitlePrograms: 'Liste des programmes',
      pageTitleAds: 'Liste des annonces',
      backToProgramList: 'Retour liste programmes',
      backToAdsList: 'Retour liste programmes',
      backToPostsList: 'Retour à la liste des posts',
      createLot: 'Créer un lot',
      createProgram: 'Créer un programme',
      createAd: 'Créer une annonce',
      createAdFromModel: "Créer une annonce à partir d'un modèle",
      createProgamFromModel: "Créer un programme à partir d'un modèle",
      createlotFromModel: "Créer un lot à partir d'un modèle",
      createLand: 'Créer un terrain',
      createModel: 'Créer un modèle',
      createPost: 'Créer un post',
      filenameExportAds: 'liste_annonces',
      delete: 'Supprimer',
      postsCity: 'Ville',
      diffuseLater: {
        title: 'Programmer la diffusion de votre annonce',
        text: 'A quelle date souhaitez-vous diffuser votre annonce ?',
        subText: 'Si vous souhaitez diffuser votre annonce maintenant, activez-la depuis la liste des annonces.',
        diffusedAt: 'Diffusion le :',
        diffusionConfirmedFirstPart: 'Votre annonce sera diffusée le ',
        diffusionConfirmedSecondPart: '. D\'ici là, elle sera conservée en tant que brouillon et restera éditable. Vous allez être redirigé vers votre liste d\'annonces.',
        planDiffusion: 'Programmer la diffusion',
        reportDiffusion: 'Modifier la programmation'
      },
      contentLibrary: 'Ma bibliothèque de contenus',
      informationBienVendu: 'Informations sur le bien vendu',
      declarePostAsDeleteByNo: 'Non, supprimer le bien',
      declarePostAsSoldByYes: 'Oui, j\'ai vendu le bien',
      bienVendu: 'Bien vendu',
      confirmBienVendu: 'Confirmer la saisie de votre bien vendu ?',
      newBienVendu: 'Créer un bien vendu',
      daysRemaining: 'jours restants',
      commercial: 'Commercial',
      nbAnnonces: 'Annonces actives',
      annoncesActivesDecroissantes: 'annonces décroissantes',
      annoncesActivesCroissantes: 'annonces croissantes',
      commercialDecroissant: 'commercial décroissant',
      commercialCroissant: 'commercial croissant',
      graphAnnoncesCommerciauxTitle: "Répartition du nombre d'annonces actives par commerciaux",
      graphAnnoncesCommerciauxNoData: 'Pas de données',
      graphAnnoncesCommerciauxSubtitle: 'Annonces actives'
    },
    dialog: {
      duplicateTitle: 'Dupliquer votre annonce',
      duplicateText: 'Etes-vous sûr de vouloir dupliquer votre annonce ?',
      duplicateReference: 'Saisissez une référence pour votre annonce dupliquée (facultatif) : ',
      duplicatePlaceholder: 'Saisissez une référence pour votre annonce dupliquée (facultatif)',
      duplicateLoading: 'Duplication en cours...',
      duplicateNotificationSuccess: 'Votre annonce a bien été dupliquée avec la référence {{ reference }}',
      duplicateNotificationError: "Une erreur s'est produite lors de la duplication de votre annonce",
      deleteTitle: 'Supprimer votre annonce',
      deleteText: 'Etes-vous sûr de vouloir supprimer votre annonce ?',
      deleteTextSoldProductOption: 'Vous souhaitez supprimer cette annonce. Ce bien a t-il été vendu par vos soins ?',
      deleteNotification: 'Votre annonce a bien été supprimée',
      adUpdatedNotification: 'Votre annonce a bien été mise à jour',
      modelDeleteTitle: 'Suppression du modèle',
      modelDeleteText: 'Etes-vous sûr de vouloir supprimer ce modèle ?',
      selectModelTitle: 'Sélectionnez parmi vos modèles existants ci-dessous',
      selectModelTitleCmiste: 'Souhaitez-vous utiliser un modèle pour créer votre annonce ?',
      selectModel: 'Sélectionnez un modèle',
      selectModelProgram: 'Ou sélectionnez un programme',
      selectTerrain: 'Sélectionnez un terrain',
      selectListTerrain: 'Sélectionnez parmi votre liste de terrains',
      selectListModel: 'Sélectionnez parmi votre liste de modèles',
      propertyType: 'Sélectionnez un type de bien',
      createFromModelTitle: 'Créer une annonce à partir de ce modèle',
      createFromModelText: 'Etes-vous sûr de vouloir créer une annonce à partir de votre modèle ?',
      selectReference: 'Saisissez une référence pour votre annonce créée ',
      selectReferencePlaceholder: 'Saisissez une référence pour votre annonce créée',
      textCreateLot: "Pour créer un lot, veuillez choisir le programme auquel le rattacher dans la liste ci-dessous puis cliquer sur le bouton \"Gérer les lots\". Vous aurez ensuite la possibilité de créer un lot à partir d'un modèle, retourner à la liste des programmes, créer un nouveau lot et consulter la liste des lots déjà rattachée à ce programme.",
      confirm: 'Confirmer',
      delete: 'Supprimer',
      cancel: 'Annuler',
      draftPortalSelectionTitle: 'Mise en brouillon',
      draftPortalSelectionText: 'Votre annonce possède une sélection de portails. Souhaitez-vous conserver cette sélection lors de la réactivation ?',
      draftPortalSelectionText_plural: 'Vos annonces possèdent une sélection de portails. Souhaitez-vous conserver cette sélection lors de la réactivation ?',
      draftPortalSelectionKeep: 'Conserver la sélection',
      draftPortalSelectionClear: 'Désélectionner les portails',
      selectProgram: 'Veuillez choisir le programme auquel vous souhaitez rattacher votre lot.',
      choiceOfProgram: 'Choix du programme',
      lengthSelectedExceeded: 'La longueur de votre sélection excède {{length}} annonces',
      archiveMyPost: 'Archiver mon annonce',
      dontDisplayAnymore: 'Ne plus afficher',
      close: 'Fermer',
      unPublishNOK: 'Votre annonce doit être dépubliée avant que vous puissiez l\'archiver définitivement.',
      archiveConfirm: 'L\'archivage d\'une annonce de bien vendu est définitive et irréversible. L\'annonce ne sera plus accessible dans votre Espace Client.\n' +
        '      Confirmez-vous l\'archivage de cette annonce ?'
    },
    card: {
      model: 'Modèle',
      ref: 'Réf',
      actionsOnThisAd: 'Actions sur cette annonce',
      seeLots: 'Voir les lots',
      manageLots: 'Gérer les lots',
      details: 'Détails',
      edit: 'Éditer',
      diffuse: 'Diffuser',
      duplicate: 'Dupliquer',
      useThisModel: 'Utiliser ce modèle',
      useThisLand: 'Utiliser ce terrain',
      presenceReport: 'Rapport de présence',
      delete: 'Supprimer',
      contacts: 'Contacts',
      privateNote: 'Note privée',
      managePosts: 'Posts',
      noData: 'Aucune donnée disponible pour le moment...',
      selectAll: 'Tout sélectionner',
      deSelectAll: 'Tout désélectionner',
      reference: 'Référence',
      title: 'Titre'
    },
    components: {
      picturesTitle: 'Photos',
      picturesText: 'Gérez ici les photos de votre bien. <strong>La première image activée correspond ' +
                    "à l'image principale de votre annonce et lors de la diffusion sur les réseaux sociaux.</strong>",
      picturesButton: 'Ajouter une ou plusieurs images',
      picturesDialogTitle: 'Sélectionner la source des images à ajouter...',
      picturesDialogTextTop: 'A partir de votre ordinateur ou appareil mobile',
      picturesDialogTextMiddle: '<em>Cliquez ici</em> ou glissez-déposez les fichiers',
      picturesDialogTextBottom: 'Fichiers jpg/png/webp/avif avec une taille inférieure à 10Mo <br> {{max}} images maximum',
      picturesDialogTextBottomEdito: 'Fichiers jpg/png/webp/avif avec une taille inférieure à 10Mo <br><br> Nous vous conseillons l\'upload de 10 images maximum.\n' +
        'Attention chaque réseau social dispose de ses propres règles de diffusion en terme de nombre de photos publiées par post.\n' +
        '<br><br>Les visuels uploadés ici seront repris sur les posts des réseaux sociaux sélectionnés ainsi que dans le même ordre d\'affichage.',
      picturesButtonCancel: 'Annuler',
      picturesButtonAdd: 'Ajouter les images',
      picturesButtonConverting: 'Conversion en cours...',
      picturesButtonDelete: 'Supprimer',
      heicConversionPending: 'Sera converti par le serveur',
      otherMediasTitle: 'Médias additionnels',
      otherMediasText: 'Renseignez les emplacements des différents médias additionnels.',
      otherMediasVirtualVisit: 'Visite virtuelle',
      otherMediasType: 'Type de media',
      otherMediasTypeTxt: 'Type de média que vous souhaitez intégrer vers un support en ligne',
      otherMedias: 'Autre media',
      otherMediasTxt: 'Ajoutez une URL qui redirige vers un autre support en ligne (animation, vidéo, ...)',
      otherMediasVirtualVisitText: 'Ajoutez une URL vers une page présentant une visite virtuelle du bien',
      otherMediasTestLink: 'Tester le lien',
      otherMediasAttachedFiles: 'Pièces jointes',
      otherMediasAttachedFilesText: 'Insérez des pièces-jointes depuis votre ordinateur ou appareil mobile',
      otherMediasAttachedFilesButton: 'Ajouter une pièce-jointe',
      customizedFormElement: 'Élément de formulaire personnalisé',
      postalCodePlaceholder: 'Ex : 97132',
      cityPlaceholder: 'Ex : Issy-les-Moulineaux',
      adPerformance: "Performance de l'annonce",
      forMoreInformation: 'Pour plus de renseignements contactez ',
      urlVideo: 'Url vidéo',
      propertyAvailability: 'Disponibilité du bien',
      availabilityStartDate: 'Date de début de disponibilité'
    },
    edit: {
      changeMassUsersTitle: 'Changer d\'utilisateur',
      yes: 'Oui',
      no: 'Non',
      edit: 'Editer',
      achat: 'Achat',
      loa: 'Location avec option d\'achat',
      lld: 'Location longue durée',
      loyerMontantVo: 'Montant du loyer',
      dureeLocationLoa: 'Durée de la location',
      kilometrageMaxLoa: 'Kilométrage maximum',
      kilometrageAutomatic: 'Pour les véhicules neufs, le kilométrage est automatiquement fixé à 0.',
      financementApport: 'Montant de l\'apport',
      servicesInclusLoyer: 'Services inclus dans le loyer',
      urlMentionsLegalesLoa: 'Lien URL des mentions légales',
      legalNotices: {
        dialogDeleteTitle: 'Supprimer les mentions légales sélectionnées',
        dialogDeleteText: 'Etes-vous sûr de vouloir supprimer ces mentions légales ?',
        dialogUpdateTitle: 'Modifier le modèle de mentions légales sélectionné',
        dialogUpdateNoticesTitle: 'Titre de vos mentions légales',
        dialogUpdateNoticesText: 'Texte de vos mentions légales',
        dialogButtonCancel: 'Annuler',
        dialogButtonConfirm: 'Confirmer',
        dialogButtonUpdateOnlyForThisAd: 'Utiliser uniquement pour cette annonce',
        dialogButtonUpdateModel: 'Mettre à jour le modèle',
        title: "Mentions légales de l'offre",
        description: 'Pour ajouter des mentions légales à votre annonce, sélectionnez parmi une liste existante de modèles ou ' +
            'créez de nouvelles mentions légales que vous pourrez également enregistrer en tant que nouveau modèle.',
        chooseModel: 'Choisissez parmi un modèle',
        chooseModelPlaceholder: 'Selectionnez dans votre liste de mentions légales',
        buttonUse: 'Utiliser',
        buttonSave: 'Enregistrer',
        buttonEdit: 'Modifier',
        tooltipUse: "En cliquant sur \"Utiliser\" vous choisissez d'utiliser ces mentions légales pour votre annonce en cours.",
        tooltipSave: 'En cliquant sur "Enregistrer", vous sélectionnez ces mentions légales pour votre annonce ' +
            'en cours et les enregistrer en tant que nouveau modèle',
        selectedNoticesText: 'Texte des mentions légales sélectionnées',
        orCreateNoticesText: 'Ou créez vos mentions légales',
        newNoticesTitle: 'Titre de vos mentions légales',
        newNoticesText: 'Texte de vos mentions légales',
        messageSuccess: 'Les mentions légales ont bien été ajoutées au texte de votre annonce qui se trouve dans l\'onglet ' +
            '"Information principales". Nous vous invitons à les vérifier avant de valider votre annonce pour diffusion.',
        messageDeleteSuccess: 'Vos mentions légales sélectionnées ont bien été supprimées',
        messageDeleteError: 'La suppression de vos mentions légales a posé problème',
        messageEmptySelection: 'Vous n\'avez pas sélectionné de mentions légales',
        messageUpdateError: 'Un problème a été rencontré dans la mise à jour de vos mentions légales.'
      },
      publish: 'Publier',
      now: 'Maintenant',
      scheduled: 'Planifier',
      spread: 'Diffuser',
      deleteSchedule: 'Supprimer la planification',
      beneficieTVA7: 'Bénéficie de la TVA 7%',
      beneficieTVA5: 'Bénéficie de la TVA 5,5%',
      save: 'Enregistrer',
      saveModifications: 'Enregistrer les modifications',
      saveDraft: 'Enregistrer en brouillon',
      createModel: 'Créer en tant que modèle',
      createAsLand: 'Créer en tant que terrain',
      deleteModel: 'Supprimer le modèle',
      deleteLand: 'Supprimer le terrain',
      cancel: 'Annuler',
      pageTitleLot: 'Créer un lot',
      pageTitleProgram: 'Créer un programme',
      pageTitleModele: 'Editer un modèle',
      pageTitleAd: 'Créer une annonce',
      alertBeforeLeave: 'Êtes-vous certain de vouloir quitter la saisie de votre annonce ? Toutes les informations renseignées seront alors perdues.',
      mainInformationTitle: 'Informations principales',
      fuel: 'essence',
      electric: 'électrique',
      moreInformationTitle: 'Informations complémentaires',
      mainInformationText: 'Tous les champs sont obligatoires. Ils permettent de déterminer les grandes caractéristiques de ' +
                           'votre annonce. <br><br> Remplissez les champs suivants pour pouvoir publier votre annonce :',
      offerType: "Type d'offre",
      propertyType: 'Type de bien',
      reference: "Référence de l'annonce",
      tooltipReference: 'Attention afin de respecter les critères de publication de nos partenaires, nous vous ' +
          'conseillons de ne pas dépasser les 20 caractères pour cette référence.',
      tooltipEquipementsAndOptions: 'Attention, la saisie des équipements doit se faire manuellement grâce à la liste proposée.' +
      '<br/> Ce champ a pour but de venir compléter les éléments présents ci-dessus.' +
      '<br/> Veuillez saisir chaque libellé en les séparant par des virgules.' +
      '<br/> Merci de ne pas saisir de phrases, de ne pas faire de copier-coller et de ne pas utiliser d\'autres éléments de ponctuation.',
      title: "Titre de l'annonce",
      titlePrintableFile: 'Titre pour les fiches à imprimer',
      titlePrintableFileMaxLength: 'Max 20 caractères',
      tooltipTitlePrintableFile: 'Si le titre de l\'annonce est trop long, vous pouvez renseigner un titre spécifique pour vos fiches à imprimer de 20 caractères maximum. Ce titre ne sera pas diffusé sur les portails.',
      vehiculeImporte: "Permet de définir s'il sagit d'un véhicule importé et de saisir une immatriculation étrangère.",
      vehiculeImportPaysTooltip: "Champ libre : renseignez le pays d'origine du véhicule (France, Allemagne, etc.).",
      informationsComplementaires: 'Ce champ ne doit pas contenir les équipements, mais des informations complémentaires comme par exemple les services à l\'achat, des précisions sur les frais lors de la vente, ou des informations sur le point de vente',
      price: 'Prix',
      startingPrice: 'Enchère mise à prix',
      priceIncludingVAT: 'Prix TTC',
      priceExcludingVAT: 'Prix HT',
      rent: 'Loyer',
      obligationToClearBrush: 'Obligation débroussaillement',
      description: 'Description',
      adText: "Texte de l'annonce",
      vehicleType: 'Type de véhicule',
      warranty: 'Garantie',
      location: 'Localisation',
      locationProximityAndSituation: 'Proximité et situation',
      locationPropertyTitle: 'Localisation du bien',
      locationPropertyText: "Renseignez l'adresse du bien ainsi que la localisation telle que vous souhaiteriez qu'elle apparaisse sur les " +
                            "annonces. <br><br> Attention : n'activez la communication de l'adresse exacte que si vous avez respecté certaines règles.",
      programType: 'Type de programme',
      selectTypePlaceholder: 'Choisir un type...',
      linkToProgramOnline: 'Lien vers le programme en ligne',
      showPriceTooltip: 'Si vous ne souhaitez pas afficher le prix de votre bien, cliquez sur "non" et il sera indiqué "nous consulter"',
      typeLand: 'Terrain',
      typeLandHouse: 'Programme terrain + maison',
      mergeFromModels: 'Créer à partir de la bibliothèque de contenus',
      address: 'Adresse',
      programAddressTitle: 'Adresse du programme',
      programAddressText: "Renseignez la localisation du programme telle que vous souhaiteriez qu'elle apparaisse sur les " +
                          "annonces. <br><br>Attention : n'activez la communication de l'adresse exacte que si vous" +
                          'avez respecté certaines règles.',
      exactAddressTooltip: "Si vous cochez sur Oui, l'adresse exacte de votre bien sera visible sur l'annonce. " +
                                  'Sinon, nous vous proposons de ne mentionner que la ville.',
      locationToPublishTitle: 'Localisation à publier',
      locationToPublishTooltip: 'Ces données seront celles publiées sur les portails de publication, permettant la géolocalisation de votre annonce.',
      locationToPublishTooltipVo: "Les informations 'Code postal' et 'Ville' permettront un meilleur" +
                                  '<br/>enrichissement de la géolocalisation de votre annonce mais ne seront pas' +
                                  '<br/>publiées par les portails. Vous pouvez les renseigner si elles diffèrent' +
                                  '<br/>des données que vous souhaitez publier sur Internet',
      interiorTitle: 'Intérieur',
      interiorServices: 'Prestations intérieures',
      otherInteriorServices: 'Autres prestations intérieures',
      exteriorServices: 'Prestations extérieures',
      exactAddressTitle: 'Adresse précise',
      saleDetailsTitle: 'Détails de commercialisation',
      lastOpportunities: 'Dernières opportunités',
      target: 'Cible',
      virginDPEMessage: "À titre exceptionnel […] en l'absence justifiée de relevés de consommation, les éléments requis […] doivent rester vierges.",
      contactTitle: 'Coordonnées de contact',
      contactText: 'Indiquez les coordonnées de contact que vous souhaitez afficher.',
      contactFirstnameLastname: 'Prénom/Nom',
      internationalTitle: 'International',
      saleTitle: 'Demande de vente de bien',
      saleTitleShort: 'Vente',
      saleNewTitle: 'Vente de neuf',
      leaseTransferTitle: 'lease transfer',
      goodwillTitle: 'Fond de commerce',
      tariffTitle: 'Tarif',
      auctionsTitle: 'Enchères',
      rentalTitle: 'Location',
      saleRentalTitle: 'Vente ou location',
      fillAdPriceDetails: 'Renseignez les informations tarifaires de votre annonce.',
      copropertyTitle: 'Copropriété',
      fillCopropertyInformation: 'Renseignez les informations si le bien est soumis au statut de la copropiété.',
      mandateTitle: 'Mandat',
      fillMandateInformation: 'Indiquez les informations concernant le mandat pour ce bien.',
      equipmentsAndOptionsTitle: 'Équipements et options',
      equipmentsAndOptionsText1: 'Pour enrichir votre annonce, vous pouvez cocher les équipements et options parmi la liste personnalisable ci-contre ou utiliser le champ libre.',
      equipmentsAndOptionsText2: "Des propositions s'afficheront automatiquement en fonction des premières lettres de votre recherche.",
      vehicleDescriptionLBC: 'Ce champ est spécifique à la diffusion Le Bon Coin qui permet désormais la publication d\'un descriptif libre du véhicule',
      carPassDescription: 'Cette donnée est une exigence du portail Autoscout pour garantir la bonne diffusion des annonces.',
      carPassUrlLabel: 'URL Car-Pass',
      carPassUrlTooltip: 'Ce site permet aux particuliers de vérifier que le kilométrage sur le Car-Pass est correct et que les dates sont authentiques.',
      lookForEquipmentPlaceholder: 'Recherchez un équipement',
      seeAvailableEquipmentsList: 'Voir liste des équipements disponibles',
      customizeFavoriteEquipment: 'Personnaliser les équipements favoris',
      availableEquipmentsList: 'Liste des équipements disponibles',
      maxFavoriteEquipments: 'Nombre d\'équipements sélectionnés en favoris',
      maxFavoriteEquipmentsTip: 'Maximum {{ max }}',
      otherInformation: 'Autres informations',
      otherEquipements: 'Autres équipements',
      otherEquipementsInfos: 'Saisissez les équipements que vous n\'avez pas trouvé dans la liste',
      otherInformationInfos: 'Saisissez les informations qui ne concernent pas les équipements',
      tabMain: 'Informations principales',
      tabDetail: "Détail de l'offre (prix, mandat...)",
      tabDetailProgram: 'Détail du programme',
      tabEquipments: 'Equipements et options',
      tabDescription: 'Description du bien',
      tabMedias: 'Médias (Photos, videos...)',
      tabInstagram: 'Diffusion instagram',
      tabLegalNotices: 'Mentions légales',
      tabInternational: 'International (textes traduits)',
      tabParametres: 'Paramètres de l\'annonce',
      copropertyAverageAnnualFee: 'Montant annuel moyen des charges de copropriété',
      copropertyMonthlyFee: 'Montant mensuel des charges de copropriété',
      intercabinetCommission: 'Commission Intercabinet',
      withoutCivilityAndName: '(sans civilité et sans prénom)',
      landlordAddress: 'Adresse du propriétaire',
      landlordOtherInformation: 'Autres informations',
      realPropertyPostalCode: 'Code postal réel du bien',
      realPropertyCity: 'Ville réelle du bien',
      goodwillPrice: 'Prix du fond de commerce',
      goodwillWallsRental: 'Location des murs',
      landPricePart: 'Dont prix du terrain',
      ancillaryCostsPart: 'Frais annexes en sus',
      includingTaxes: 'TTC',
      recoveryCondition: 'Modalité de récupération',
      rentalFeeIncludingConditionInspection: "Honoraires (honoraires d'état des lieux inclus)",
      linkToAgencyFees: "Lien vers les tarifs de l'agence",
      collateralSecurityRequired: 'Nécessite caution solidaire',
      seller: 'Vendeur',
      buyer: 'Acquéreur',
      costsWillBeBorneBy: 'Honoraire à la charge de...',
      sellerShare: 'Quote-part vendeur',
      buyerShare: 'Quote-part acheteur',
      package: 'Bouquet',
      monthlyAnnuity: 'Rente mensuelle',
      land: 'Terrain',
      checkboxLandWithSlope: 'Avec pente',
      checkboxLandServiced: 'Viabilisé',
      checkboxLandAllotment: 'Lotissement',
      checkboxLandBuildable: 'Constructible',
      propertyPartnerCompany: 'Société',
      propertyPartnerLastname: 'Nom du contact',
      propertyPartnerFirstname: 'Prénom du contact',
      propertyPartnerPhone: 'Téléphone',
      checkboxAirport: 'Aéroport',
      checkboxHighwayExit: 'Sortie autoroute',
      checkboxGare: 'Gare',
      checkboxBus: 'Bus',
      checkboxTramway: 'Tram / tramway',
      checkboxParking: 'Parking',
      checkboxShops: 'Commerces',
      checkboxMall: 'Centre commercial',
      checkboxDowntown: 'Centre ville',
      checkboxNursery: 'Crèche',
      checkboxPrimarySchool: 'Ecole primaire',
      checkboxCollege: 'Collège',
      checkboxHighSchool: 'Lycée',
      checkboxUniversity: 'Université',
      checkboxGreenSpaces: 'Espaces verts',
      checkboxSubway: 'Métro',
      cd: 'Radio CD',
      agencyFee: "Frais d'agence",
      diffuseNow: 'Enregistrer',
      diffuseLater: 'Enregistrer et programmer ma diffusion',
      adSaved: 'Les données de votre annonces ont bien été enregistrées. Votre annonce sera diffusée le ',
      redirect: 'Vous allez être redirigé vers votre liste d\'annonces.',
      adManagerTitle: "Gestionnaire de l'annonce",
      adManagerText: 'Veuillez sélectionnez parmi la liste déroulante la personne en charge de cette annonce. ' +
          "<br> Si la personne à qui vous souhaitez attribuer cette annonce n'est pas présente dans la liste, " +
          "soit c'est parce qu'elle ne dispose pas des droits d'accès nécessaire à l'Espace Client, soit vous devez l'ajouter à votre carnet de contact.",
      user: 'Utilisateur',
      createLand: 'Créer un terrain',
      model: 'Modèle',
      selectLand: 'Sélectionnez un modèle de terrain à bâtir',
      selectModel: 'Sélectionnez un modèle de maison à bâtir',
      instagramSubtitle: 'Editer depuis cet onglet les contenus à diffuser sur votre post Instagram.<br><br>Nous vous proposons un contenu à diffuser que vous pouvez modifier en intégrant des émojis et changer des éléments de texte. Vous pouvez également revenir dessus en cliquant sur le bouton "Re-générer".<br><br>Il vous sera aussi possible de diffuser plusieurs visuels que vous intégrez dans l\'onglet "Média".<br><br><strong>ATTENTION</strong><br>',
      networkTextFormat: 'Le format de vos visuels doit être adapté pour ce réseau social.',
      instagramTextPost: '<strong>Une fois votre post diffusé, son contenu ne sera plus modifiable ni supprimable depuis votre Espace Client Ubiflow.</strong>',
      instagramCaption: "800 caractères maximum, incluant vos # (30 maximum), @ (20 maximum) et le lien de l'annonce. Pour celle-ci nous vous conseillons d'indiquer une url réduite. Google URL Shortener est un bon outil pour ça.",
      alreadyBroadcastedToInstagram: 'Votre annonce est déjà partie en diffusion sur votre compte Instagram. Son contenu ne peut plus être modifié.',
      shortDescription: 'Description courte',
      tooltipTexteResume: 'Cette description sera notamment prise en compte dans votre publication Google My Business si vous avez opté pour cette diffusion.',
      generateInstagramCaption: 'Re-générer',
      generateCaption: 'Re-générer',
      resetCaption: 'Réinitialiser',
      instagramOptionDisabled: 'La diffusion de vos annonces sur Instagram n\'est pas activée. Pour cela, contactez-nous au 02 99 83 05 36.',
      GMBOptionDisabled: 'La diffusion de vos annonces sur Google My Business n\'est pas activée. Pour cela, contactez-nous au 02 99 83 05 36.',
      surfaceHabitable: 'Surface habitable',
      surfaceCommerciale: 'Surface commerciale',
      surfaceActivite: "Surface d'activité",
      surfaceLand: 'Surface du terrain',
      surfaceStationnement: 'Surface de stationnement',
      promoterProgram: 'Programme immobilier',
      miseEnCirculation: 'Mise en circulation',
      carDoorsAfter: ' portes',
      warrantyTime: 'Durée de la garantie',
      idRPLS: 'Numéro RPLS',
      location_active: 'Location active',
      location_active_nud: 'Location active vérification NUD',
      editPostNonEditablesFieldsImmo: 'Les éléments suivants ne sont pas modifiables en saisie:<br>' +
          '<br><ul>' +
          '<li>Type d\'offre</li>' +
          '<li>Type de bien</li>' +
          '<li>Référence</li>' +
          '<li>Titre de l\'annonce</li>' +
          '<li>Texte de l\'annonce</li></ul>',
      editPostNonEditablesFieldsVo: 'Les éléments suivants ne sont pas modifiables en saisie:<br>' +
          '<br><ul>' +
          '<li>Référence</li>' +
          '<li>Type de véhicule</li></ul>',
      changeMassContactsTitle: 'Sélectionnez parmi la liste déroulante le contact que vous souhaitez renseigner pour les annonces sélectionnées : ',
      commercialEntityCode: 'Code entité commerciale',
      formBienVenduTitle: 'Informations concernant la vente du bien',
      formBienVenduAnnonceTitle: 'Informations concernant l\'annonce du bien',
      bienVenduSubtitle: 'Renseigner depuis cet onglet les informations principales sur le bien que vous avez vendu. <br>' +
          '<br>' +
          'Si vous souhaitez communiquer sur ce bien vendu, Ubiflow vous propose pour chacun de vos réseaux sociaux, un post généré automatiquement sur la base de ces données et de celles de votre annonce. <br>' +
          '<br>' +
          'Vous pouvez modifier ces données et personnaliser les posts avant leur publication sur vos réseaux. <br>',
      prixVenduNet: 'Prix vendu net',
      GMBTitle: 'Informations à diffuser sur Google My Business',
      GMBSubtitle: 'Editer depuis cet onglet votre post tel que vous souhaitez le voir apparaître sur votre page Google My Business.\r\n' +
          '<br><br>' +
          'Ubiflow vous propose un post généré automatiquement sur la base des données de votre annonce.\n' +
          'Vous pouvez le modifier avant sa publication.',
      GMBSubtitle2: 'Editer depuis cet onglet votre post tel que vous souhaitez le voir apparaître sur votre fiche établissement GMB.<br><br>Ubiflow vous propose un post généré automatiquement sur la base des données de votre annonce.<br>Vous pouvez le modifier avant sa publication.',
      creationBienVendu: 'Création d\'un bien vendu',
      creationBienVenduDialogCaption: 'La saisie des informations concernant la vente d\'un bien, entraine automatiquement la dépublication' +
          ' de l\'annonce du bien sur les différents portails de diffusion, si cette dernière était publiée.',
      infoGeoRisques: 'Informations sur les risques',
      geoRisquesSubtitle: 'Un décret applicable au 01/01/2023 prévoit que l\'annonce relative à la vente ou la location d\'un bien pour lequel doit être établi l\'état des risques mentionné à l\'article L. 125-5, quel que soit son support de diffusion, comporte la mention suivante : Les informations sur les risques auxquels ce bien est exposé sont disponibles sur le site Géorisques : <a href="https://www.georisques.gouv.fr" target="_blank">www.georisques.gouv.fr</a>',
      typeTransmission: 'Type transmission',
      instagramMaxHashtagExceeded: 'Vous avez dépassé le nombre de hashtags autorisés',
      instagramMaxMentionsExceeded: 'Vous avez dépassé le nombre de mentions autorisées',
      chars: 'caractères',
      messageErrorQuartier: 'Aucun quartier officiel trouvé pour le code postal {{cp}}.',
      visite: {
        title: 'Visites',
        description: '',
        duree_publication: 'Durée de publication',
        heures: 'heures',
        lieu_visite: 'Lieu de visite',
        commentaire: 'Commentaire',
        visite: 'Visite',
        dateDebut: 'Date de la visite',
        horaire: 'Horaire de la visite',
        nombre_candidats_max: 'Nombre de visiteurs max',
        saveVisite: 'Enregistrer la visite',
        nombre_candidats_inscrits: 'Nombre de candidats inscrits',
        status: 'Statut de la visite',
        statusActive: 'Active',
        statusInactive: 'Inactive',
        confirmationAnnulationTitle: 'Annuler la visite',
        confirmationAnnulationText: 'Souhaitez-vous annuler cette visite ?',
        annuler: 'Non',
        confirmer: 'Oui',
        requiredFields: 'Veuillez remplir tous les champs requis (date, horaire et nombre de personnes)'
      },
      activitesCommercePlaceholder: 'Choisir une activité',
      affichage_privilegie: 'Coup de coeur',
      securiteBien: 'Sécurité du bien',
      systemeIncendie: 'Système incendie',
      idRegroupementAnnoncesPlaceholder: 'Numéro d\'agrégation d\' annonces concernant un même bien immobilier'
    },
    view: {
      edit: 'Modifier',
      sendByEmail: 'Envoyer par email',
      sendByEmailTitle: 'Transférer cette annonce par mail',
      sendByEmailRecipient: 'Adresse mail destinataire',
      sendByEmailMessage: 'Votre message',
      sendByEmailComment: 'Votre annonce en pièce jointe',
      sendByEmailSubject: 'Votre annonce {{ postTitle }}',
      sendByEmailAttachment: 'Annonce-{{ reference }}.pdf',
      cancel: 'Annuler',
      send: 'Envoyer',
      goBackTitleLots: 'Revenir à la liste des lots',
      goBackTitlePrograms: 'Revenir à la liste des programmes',
      goBackTitleAds: 'Revenir à la liste des annonces',
      pageTitleLot: "Détail d'un lot",
      pageTitleProgram: "Détail d'un programme",
      pageTitleAd: "Détail d'une annonce",
      print: 'Imprimer',
      printFilename: 'Mon_Annonce.pdf',
      name: 'Nom : {{ name }}',
      city: 'Ville : {{ city }}',
      cityPromoteur: 'Ville : ',
      price: 'Prix : {{ price }} {{ currency }}',
      priceMin: 'Prix : à partir de {{ price }} {{ currency }}',
      priceLowSeason: 'Tarif hebdo basse saison : {{ price }} {{ currency }}',
      priceMiddleSeason: 'Tarif hebdo moyenne saison : {{ price }} {{ currency }}',
      priceHighSeason: 'Tarif hebdo haute saison : {{ price }} {{ currency }}',
      monthlyRentChargesIncluded: 'Loyer mensuel charges comprises',
      monthlyRentChargesIncludedDisplay: '€ / mois cc',
      priceContactUs: 'Prix : Nous consulter',
      surfaceMinMax: 'Surface : de {{ min }}m² à {{ max }}m²',
      surface: 'Surface : {{ surface }}m²',
      roomsNumber: 'Nombre de pièces : {{ number }}',
      offerTypeV: 'Type offre : Vente',
      contactTitle: 'Coordonnées de contact',
      saleConditionsPrice: 'Prix',
      rent: 'Loyer',
      saleConditionsPriceVo: 'Prix : {{ price }} {{ currency }}',
      saleConditionsPriceCmiHouseLand: 'Prix maison + terrain',
      saleConditionsPriceCmiLand: 'Prix terrain',
      saleConditionsLand: 'dont prix du terrain',
      saleConditionsBuyerFee: 'Honoraire acquéreur TTC',
      gearsNumber: '{{ number }} vitesses',
      selectionVoMarchand: 'Marchand',
      selectionVo: 'Sélection VO',
      goBackTitleSelectionVo: 'Revenir à la liste sélection VO',
      contacter: 'Contacter',
      sousGarantieConstructeur: 'Sous garantie constructeur',
      contacterVendeur: 'Contacter le vendeur',
      emailReplyTo: 'Adresse mail de réponse',
      selectionVoEmailComment: 'Bonjour, je suis intéressé par le véhicule de référence \'{{ postRef }}\'',
      pricePublic: 'prix public',
      priceDealer: 'prix marchand',
      depotGarantie: 'Dépôt de garantie',
      honorairesLocation: 'Honoraires de location',
      portalLink: 'Lien du portail',
      printInfo: 'Fiche informative',
      printVitrine: 'Fiche vitrine',
      printVitrineLandscape: 'Fiche vitrine (format paysage)',
      sendVitrine: 'Envoyer fiche vitrine',
      sendInfo: 'Envoyer fiche informative',
      referenceAnnonce: 'Référence de l\'annonce',
      commercialWarranty: 'Garantie commerciale',
      without: 'Sans',
      vignette: 'Vignette',
      power: 'Puissance',
      energy: 'Energie',
      transmission: 'Transmission',
      licencePlate: 'Immatriculation',
      miseEnCirculation: 'Mise en circulation',
      equipmentsAndOptions: 'Equipements & options',
      withoutLicenceAndFuelFees: 'Hors frais d\'immatriculation et de carburant',
      weightOfVehicle: 'Poids du véhicule',
      reference: 'Référence',
      guaranteedMileage: 'Kilométrage garanti',
      nonGuaranteedMileage: 'Kilométrage non garanti',
      pdfFooterGenerated: 'Document généré le {{date}}',
      pdfFooterExclusivity: 'Exclusivité {{agency}}',
      sendVitrineLandscape: 'Envoyer fiche paysage',
      pdfVoRefPrefix: 'Réf. : ',
      pdfVoWithoutCommercialWarranty: 'Sans garantie commerciale',
      pdfVoWarrantyMonthUnit: 'mois',
      pdfVoMileageGuaranteedShortTitle: 'Garantie',
      pdfVoMileageGuaranteedShort: 'Garanti',
      pdfVoMileageNotGuaranteedShort: 'Non garanti',
      pdfVoMileageLabel: 'Kilométrage',
      pdfVoFirstRegistrationShort: 'Mise en circ.',
      pdfVoGearboxShort: 'Boîte',
      pdfVoCritairLabel: 'Crit\'air',
      pdfVoHorsepowerUnit: 'Ch',
      pdfVoContactFooterLine1: 'Plus d\'informations auprès de nos équipes',
      pdfVoContactFooterLine2: 'en concession.',
      pdfVoMainPhotoAlt: 'Photo principale du véhicule d\'occasion',
      pdfVoPriceDisclaimerPortrait: '(HORS FRAIS D\'IMMATRICULATION ET DE<br>CARBURANT)',
      pdfVoPhoneLabel: 'Téléphone',
      pdfVoEmailLabel: 'E-mail'
    },
    bienVendu: {
      createWarning: 'La saisie des informations concernant la vente d\'un bien, entraine automatiquement la dépublication de l\'annonce du bien sur les\n' +
        'différents portails de diffusion, si cette dernière était publiée.',
      formDialogCreateTitle: 'Création / enregistrement des modifications du bien vendu en cours',
      dialogConfirmBVCreationTitle: 'Confirmer la création de votre bien vendu',
      cancelCreationBienVenduTitle: 'Annuler la saisie de votre bien vendu',
      modificationSuccess: 'Votre modification a été enregistrée avec succès',
      creationSuccess: 'Votre création a été enregistrée avec succès',
      creationFailed: 'Votre création a échouée',
      dialogConfirmBVChangeTitle: 'Création / enregistrement des modifications du bien vendu en cours',
      cancelCreationBienVenduText: 'Êtes-vous certain de vouloir quitter la saisie de votre bien vendu ? Toutes les informations renseignées dans les différents onglets seront alors perdues.',
      formCreation: {
        initialPrice: 'Prix initial *',
        livingSpace: 'Surface habitable',
        roomsNumber: 'Nombre de pièces',
        energyConsumption: 'Consommation énergétique',
        streetNumber: 'N° voie',
        streetType: 'Type voie',
        streetName: 'Nom de voie',
        postalCode: 'Code postal *',
        city: 'Ville *',
        salesAgreementDate: 'Date compromis',
        buyerOrigin: 'Origine de l\'acquéreur',
        chooseOrigin: 'Choisir une origine',
        saveAndClose: 'Enregistrer et fermer',
        saveAndManagePosts: 'Enregistrer et personnaliser les posts',
        saveAndManageDiffusion: 'Enregistrer et gérer la diffusion',
        buyerFees: 'Honoraires acquéreur',
        sellerFees: 'Honoraires acheteur'
      }
    },
    report: {
      sendByEmail: 'Envoyer par email',
      print: 'Imprimer',
      goBackToAdList: 'Revenir à la liste des annonces',
      dialogTitle: 'Transférer cette annonce par mail',
      dialogEmail: 'Adresse mail destinataire',
      dialogMessage: 'Votre message',
      dialogMessagePlaceholder: 'Votre rapport de présence en pièce jointe',
      dialogCancel: 'Annuler',
      dialogSend: 'Envoyer',
      city: 'Ville',
      price: 'Prix',
      yourAdHasBeDiffusedTo: 'Votre annonce a été envoyée vers',
      yourAdIsOnlineOn: 'Votre annonce est en ligne sur',
      portals: 'portails',
      reportDate: 'Votre rapport de présence en date du',
      definition: 'Définition des termes employés',
      online: 'En ligne',
      onlineText: 'Ubiflow vérifie que votre annonce est effectivement publiée sur le portail.',
      diffused: 'Diffusée',
      sent: 'Envoyée',
      diffusedText: 'votre annonce a bien été envoyée au portail. Le portail ne retourne cependant aucune preuve de publication à Ubiflow.',
      pdfName: 'Mon_Rapport',
      emailSubject: "Votre rapport pour l'annonce {{ title }}",
      emailAttachmentFirstPart: 'Rapport-',
      globalTitle: 'Statistiques générales',
      lastIntegration: 'Date de dernière intégration',
      adsIntegrated: "Nombre d'annonces intégrées",
      adsDeleted: "Nombre d'annonces supprimées",
      exportResults: 'Exporter les résultats',
      columnAd: 'Annonce',
      columnDateCreation: 'Date de création',
      columnDateModification: 'Date de modification',
      columnPictures: 'Nb. photos',
      filenameExportIntegration: 'export_rapport_integration',
      filterRejected: 'Annonces rejetées',
      filterWarn: 'Avertissement',
      numberCountERROR: 'Nombre des messages d\'erreurs',
      numberCountWARN: 'Nombre des messages d\'avertissements'
    },
    privateNote: {
      postReference: 'Référence',
      postPrice: 'Prix',
      postLocation: 'Localisation',
      postSurface: 'Surface',
      PostNumberRoom: 'Nombre de pièces',
      generalInformationTitle: 'Information générales',
      postPrivateNote: "Note privée de l'annonce",
      postBrand: 'Marque',
      postModel: 'Modèle',
      postEnergie: 'Energie',
      contenueNote: 'Contenu de la note',
      messageSucces: 'Votre note privée a bien été mise à jour'
    },
    linkedIn: {
      asideTitle: 'Informations à diffuser sur LinkedIn',
      asideText: 'Editer depuis cet onglet les contenus à diffuser sur\n' +
        'votre post LinkedIn.<br><br>' +
        'Nous vous proposons un contenu à diffuser que\n' +
        'vous pouvez modifier en intégrant des émojis et changer des éléments de texte. Vous pouvez également revenir dessus en cliquant sur le bouton "Re-générer".<br><br>' +
        'Vous pourrez également diffuser plusieurs visuels intégrés depuis l\'onglet "Media"<br><br>' +
        'ATTENTION<br><br>' +
        'Une fois votre post diffusé, son contenu ne sera\n' +
        'plus modifiable ni supprimable depuis votre\n' +
        'Espace Client Ubiflow.\n',
      notActivated: 'La diffusion de vos annonces sur LinkedIn n\'est pas activée. Pour cela, contactez-nous au 02 99 83 05 36.',
      generate: 'Re-générer'
    },
    descriptionTitle: 'Description',
    offerDescription: "Description de l'offre",
    vehicleDescription: 'Description du véhicule',
    carPassTitle: 'Car-Pass',
    offerType: "Type d'offre",
    propertyType: 'Type de bien',
    priceWithoutTaxes: 'Prix (hors frais annexes)',
    ancillaryCosts: 'Frais annexes en sus',
    defiscTitle: 'Avantages investissement (defisc...)',
    offerTitle: 'Bon plan',
    offerDetail: "Détail de l'offre",
    certificationsAndLabelsTitle: 'Certifications et labels',
    energyTitle: 'Energie, chauffage',
    heatTitle: 'Chauffage',
    exteriorTitle: 'Extérieur',
    interiorTitle: 'Intérieur',
    propertyDescriptionTitle: 'Description du bien',
    environmentTitle: 'Environnement',
    idSite: 'Id Site',
    urlAnnonceSiteAnnonceur: "URL de l'annonce sur votre site",
    informationsComplementaires: 'Informations complémentaires',
    titreMetaWeb: 'Méta données "title" de la page web',
    descriptionMetaWeb: 'Méta données "description" de la page web',
    pushMenu: 'Push menu',
    coupDeCoeur: 'Coup de coeur',
    addVisiteVirtuelle: 'Ajouter une visite virtuelle',
    propertyConditionTitle: 'Etat du bien',
    coPropertyInformationTitle: 'Informations de co-propriété',
    propertyPartnerTitle: 'Partenaire foncier',
    dpeTitle: 'DPE',
    isolationThermiqueSolaireTitle: 'Isolation thermique et solaire',
    securityDeposit: 'Dépôt de garantie',
    myAd: 'Mon annonce',
    saleConditionsTitle: 'Conditions de vente',
    complementaryInformationTitle: 'Informations complémentaires',
    equipments: 'Équipements',
    comfortEquipmentsTitle: 'Équipements de confort présents',
    securityEquipmentsTitle: 'Équipements de sécurité présents',
    otherEquipmentsTitle: 'Équipements divers présents',
    generalInformationTitle: 'Information générales',
    houseTitle: 'Maison',
    landTitle: 'Terrain',
    buildingLandTitle: 'Terrain à bâtir',
    locationTitle: 'Localisation',
    servicesTitle: 'Prestation',
    labelsAndCertificationsTitle: 'Labels et Qualifications',
    equipementPresent: 'Equipements présents',
    programs: 'Programme',
    loyer_an_m2: 'Loyer HT-HC par m2/an',
    adUpdated: 'Votre annonce a été modifiée avec succès',
    adResetDialogTitle: 'Réinitialisation du post ',
    adResetDialog: 'Souhaitez-vous vraiment réinitialiser ce post ?',
    networks: {
      resetCaption: 'réinitialiser',
      commercialText1: 'La diffusion de vos posts d\'annonces sur ',
      commercialText1Bis: 'n\'est pas activée.',
      commercialText2: 'Saviez-vous que vous pouvez également souscrire, en plus de cette diffusion, à la génération de vos posts grâce à notre Intelligence Artificielle ?',
      commercialText3: 'La diffusion sur ',
      commercialText3Bis: ' vous intéresse, ainsi que la rédaction automatique des posts par l\'IA ?',
      videoTitre: 'Vidéo',
      videoTexte: "Vous pouvez renseigner une URL de vidéo pour illustrer votre post d'annonce à la place des photos associées à votre annonce. Veillez à ce qu'il s'agisse bien d'une URL de vidéo et non celle d'un player type Youtube ou Dailymotion qui ne serait pas pris en compte par les réseaux sociaux.",
      videoUrlError: "L'url de la vidéo n'est pas valide",
      videoButtonClap: 'Copier le lien Flow Vidéo',
      videoButtonGotoClap: 'Vous pouvez également générer une vidéo avec',
      videoEditoTitre: 'Ou le lien de votre vidéo',
      videoEditoSousTitre: 'Si vous avez ajouté une ou plusieurs images, en renseignant un lien vidéo, vos images ne seront pas visibles sur vos réseaux sociaux lors de la diffusion des posts. Le média vidéo est en effet prioritaire lors de la diffusion de vos posts.',
      videoEditoHelp: 'Le lien que vous insérez ici doit être un lien de fichier hébergé par vos soins. Ne pas renseigner d\'URL Youtube, Viméo ou autre qui sont des liens de lecture. Ceux-ci ne seront pas acceptés par les réseaux sociaux.',
      instagram: {
        asideTitle: 'POST INSTAGRAM',
        asideText: 'Pour vous faire gagner du temps, Ubiflow vous propose de créer des contenus personnalisés grâce à l\'Intelligence Artificielle, en s\'appuyant sur les données de votre annonce. Cette fonctionnalité est disponible avec notre offre dédiée.',
        asideInfoTitle: 'INFORMATIONS INSTAGRAM',
        asideInfoText1: '1- La diffusion de votre post embarque vos 10 premières photos.',
        titleTextarea: 'GESTION DE VOTRE POST SUR INSTAGRAM',
        textInfoTextarea1: 'Vous pouvez sélectionner plusieurs suggestions avant validation et faire votre choix. Vous avez également la possibilité de modifier le contenu, d\'y ajouter des émojis ou de l\'enrichir avec des hashtags pertinents.',
        textInfoTextarea2: 'Si besoin, vous pouvez revenir à la proposition d\'origine à tout moment en cliquant sur le bouton "Réinitialiser".',
        textInfoIA: 'Pour les posts générés grâce à notre Intelligence Artificielle, la modification d\'un ou plusieurs critères de votre annonce impliquera une mise à jour totale ou partielle du post initialement généré et cela tant que le post n\'est pas diffusé.',
        titleWarning: 'ATTENTION',
        textWarning: 'Une fois votre post diffusé, son contenu ne sera plus modifiable ni supprimable depuis votre Espace Client Ubiflow.',
        infoNumberCharacters: 'Nombre de caractères autorisés :',
        popupNumberCharacters: 'Vous avez dépasser le nombre maximum de caractères.'
      },
      facebook: {
        asideTitle: 'POST FACEBOOK',
        asideText: 'Pour vous faire gagner du temps, Ubiflow vous propose de créer des contenus personnalisés grâce à l\'Intelligence Artificielle, en s\'appuyant sur les données de votre annonce. Cette fonctionnalité est disponible avec notre offre dédiée.',
        asideInfoTitle: 'INFORMATION FACEBOOK',
        asideInfoText1: '1- La diffusion de votre post embarque vos 10 premières photos.',
        titleTextarea: 'GESTION DE VOTRE POST SUR FACEBOOK',
        textInfoTextarea1: 'Vous pouvez sélectionner plusieurs suggestions avant validation et faire votre choix. Vous avez également la possibilité de modifier le contenu, d\'y ajouter des émojis ou de l\'enrichir avec des hashtags pertinents.',
        textInfoTextarea2: 'Si besoin, vous pouvez revenir à la proposition d\'origine à tout moment en cliquant sur le bouton "Réinitialiser".',
        textInfoIA: 'Pour les posts générés grâce à notre Intelligence Artificielle, la modification d\'un ou plusieurs critères de votre annonce impliquera une mise à jour totale ou partielle du post initialement généré et cela tant que le post n\'est pas diffusé.',
        titleWarning: 'ATTENTION',
        textWarning: 'Une fois votre post diffusé, son contenu ne sera plus modifiable ni supprimable depuis votre Espace Client Ubiflow.'
      },
      google: {
        asideTitle: 'POST GOOGLE BUSINESS PROFIL',
        asideText: 'Pour vous faire gagner du temps, Ubiflow vous propose de créer des contenus personnalisés grâce à l\'Intelligence Artificielle, en s\'appuyant sur les données de votre annonce. Cette fonctionnalité est disponible avec notre offre dédiée.',
        titleTextarea: 'GESTION DE VOTRE POST SUR GOOGLE BUSINESS PROFIL',
        asideInfoTitle: 'INFORMATIONS GOOGLE BUSINESS PROFIL',
        asideInfoText1: '1- La diffusion de votre post embarque 1 photo.',
        textInfoTextarea1: 'Vous pouvez sélectionner plusieurs suggestions avant validation et faire votre choix. Vous avez également la possibilité de modifier le contenu, d\'y ajouter des émojis ou de l\'enrichir avec des hashtags pertinents.',
        textInfoTextarea2: 'Si besoin, vous pouvez revenir à la proposition d\'origine àtout moment en cliquant sur le bouton "Réinitialiser".',
        textInfoIA: 'Pour les posts générés grâce à notre Intelligence Artificielle, la modification d\'un ou plusieurs critères de votre annonce impliquera une mise à jour totale ou partielle du post initialement généré et cela tant que le post n\'est pas diffusé.',
        titleWarning: 'ATTENTION',
        textWarning: 'Une fois votre post diffusé, son contenu ne sera plus modifiable ni supprimable depuis votre Espace Client Ubiflow.'
      },
      linkedin: {
        asideTitle: 'POST LINKEDIN',
        asideText: 'Pour vous faire gagner du temps, Ubiflow vous propose de créer des contenus personnalisés grâce à l\'Intelligence Artificielle, en s\'appuyant sur les données de votre annonce. Cette fonctionnalité est disponible avec notre offre dédiée.',
        asideInfoTitle: 'INFORMATIONS LINKEDIN',
        asideInfoText1: '1- La diffusion de votre post embarque vos 10 premières photos.',
        titleTextarea: 'GESTION DE VOTRE POST SUR LINKEDIN',
        textInfoTextarea1: 'Vous pouvez sélectionner plusieurs suggestions avant validation et faire votre choix. Vous avez également la possibilité de modifier le contenu, d\'y ajouter des émojis ou de l\'enrichir avec des hashtags pertinents.',
        textInfoTextarea2: 'Si besoin, vous pouvez revenir à la proposition d\'origine à tout moment en cliquant sur lebouton "Réinitialiser".',
        textInfoIA: 'Pour les posts générés grâce à notre Intelligence Artificielle, la modification d\'un ou plusieurs critères de votre annonce impliquera une mise à jour totale ou partielle du post initialement généré et cela tant que le post n\'est pas diffusé.',
        titleWarning: 'ATTENTION',
        textWarning: 'Une fois votre post diffusé, son contenu ne sera plus modifiable ni supprimable depuis votre Espace Client Ubiflow.'
      }
    },
    IA: {
      textSpinnerIA: 'Notre intelligence artificielle est en train de vous concocter un super post. Cela ne saurait tarder...',
      textSpinnerIAReview: 'Notre intelligence artificielle est en train de vous concocter une superbe réponse. Cela ne saurait tarder...'
    },
    instagramTitle: 'Informations à diffuser sur Instagram',
    immoAncien: 'Immo ancien',
    newPrograms: 'Programmes neufs',
    houseProgram: 'Programme maison',
    apartmentProgram: 'Programme appartement',
    subdivision: 'Lotissement',
    officeProgram: 'Programme bureau',
    mixedProgram: 'Programme mixte',
    postType: "Type d'annonce",
    facebook: {
      asideTitle: 'Informations à diffuser sur votre page Facebook',
      asideText: 'Editer depuis cet onglet les contenus à diffuser sur votre post Facebook.' +
          '<br><br>Nous vous proposons un contenu à diffuser que vous pouvez modifier en intégrant des émojis et changer des éléments de texte. Vous pouvez également revenir dessus en cliquant sur le bouton "Re-générer".' +
          '<br><br>Il vous sera aussi possible de diffuser plusieurs visuels que vous intégrez dans l\'onglet "Média".',
      notActivated: 'La diffusion de vos annonces sous forme de posts Facebook n\'est pas activée. Pour cela, contactez-nous au 02 99 83 05 36.',
      alreadyBroadcasted: 'Votre annonce est déjà partie en diffusion sur votre page Facebook. Son contenu ne peut plus être modifié.',
      generate: 'Re-générer'
    },
    clap: {
      title: 'Génération de votre vidéo grâce à Flow Vidéo',
      toKnowTitle: 'À savoir',
      toKnowText: "En cliquant sur \"Générer ma vidéo\", la diffusion de votre post sur les réseaux sociaux est automatique. Votre vidéo vous est livré sous forme d'url que vous pouvez utiliser à votre guise sur d'autres supports.",
      attentionTitle: 'Attention',
      attentionText: 'Veuillez vous assurer que votre annonce contient au minimum 5 images afin de garantir un bon rendu de votre vidéo.',
      disabledText: 'Le produit de génération de vidéos n\'est pas activée. Pour cela, contactez-nous au 02 99 83 05 36.',
      informationTitle: 'Informations sur vos vidéos',
      forfaitClapTitle: 'Forfait mensuel',
      forfaitClap: '{{ quotaMax }} vidéos',
      monitoringClapTitle: 'Nombre de vidéos consommées',
      monitoringClapTooltip: 'Le nombre de vidéos cumulées correspond à votre forfait mensuel + les vidéos non utilisées les mois précédents',
      monitoringClap: '{{ nbClapGeneres }}/{{ nbClapRestants }} cumulées',
      generateClapButton: 'Générer ma vidéo',
      checkUrlClapButton: 'Rafraichir pour obtenir le lien de ma vidéo',
      downloadClapButton: 'Télécharger la vidéo',
      patientTextBegin: 'Votre vidéo est en cours de création.Veuillez patienter quelques minutes avant de cliquer sur le bouton.',
      patientTextEnd: 'Si vous ne voulez pas attendre, vous pouvez également continuer de naviguer sur votre Espace Client Ubiflow et revenir dans quelques minutes.',
      msgClapInProgress: 'Génération vidéo en cours',
      msgClapEnded: 'Génération vidéo terminée !',
      msgClapLaunch: 'Lancement génération vidéo'
    },
    socialNetworks: {
      dialogPagesSelection: 'Merci de sélectionner la page Facebook sur laquelle vous souhaitez diffuser vos publications',
      messageFacebookAutologin: 'Identifiez-vous à nouveau avec votre compte pro afin de renouveler les droits de publication de l\'application',
      titleFacebookPages: 'Pages autorisées pour la publication des posts',
      facebookDeconnexion: 'Se déconnecter de Facebook',
      googleDeconnexion: 'Se déconnecter de Google',
      dialogLocationsSelection: 'Merci de sélectionner votre établissement Google sur lequel vous souhaitez diffuser vos publications',
      dialogOrganizationsSelection: 'Merci de sélectionner votre organisation Linkedin sur lequel vous souhaitez diffuser vos publications',
      newPost: {
        introText: 'Vous vous apprêtez à créer un nouveau contenu à publier sur vos réseaux sociaux. Pour cela choisir dans un premier temps le type de post parmi ceux qui vous sont proposés et suivez les instructions.',
        createPostLabel: 'Vous souhaitez créer un post',
        selectPostType: 'Choisir le type de post',
        fromAd: 'A partir d\'une annonce',
        fromSoldProperty: 'A partir d\'un bien vendu',
        editorial: 'Editorial',
        fromPostTemplate: 'A partir d\'un modèle de post éditorial',
        selectRelatedAd: 'Sélectionner l\'annonce concernée',
        title: 'Titre',
        reference: 'Référence',
        price: 'Prix',
        alreadyPosted: 'Ce post a déjà été créé et diffusé sur un ou plusieurs réseaux sociaux à partir de cette annonce.',
        noEditable: 'Vous ne pouvez plus l\'éditer.',
        cancel: 'Annuler',
        editPost: 'Editer le post',
        validateAndContinue: 'Valider et poursuivre'
      }
    }
  },
  portals: {
    broadcast: {
      quotaProgram: 'Dont programmes',
      quotaLot: 'Dont lots',
      noAdSelected: 'Aucune annonce sélectionnée',
      selectedAds: 'annonce sélectionnée',
      selectedAds_plural: 'annonces sélectionnées',
      disableDiffusion: 'Désactiver la diffusion',
      diffuseAds: 'Diffuser ces annonces',
      noSelectionWarning: 'Veuillez sélectionner au moins une annonce',
      quota: 'Quota',
      quotaUnlimited: 'Illimité',
      lastDiffusion: 'Dernière diffusion',
      lastDiffusionUnknown: 'Inconnue',
      selectedAdsPortal: 'Annonce(s) sélectionnée(s)',
      broadcastedAds: 'Annonce(s) diffusée(s)',
      tooltipSelectedAdsPortals: 'Total des annonces sélectionnées diffusées et non diffusées.',
      remainingMessageQuota: 'Attention, il ne vous reste que {{ number }} annonces pour atteindre votre quota',
      reachedAdsLimitQuotas: 'Attention, vous avez atteint votre quota, vous ne pouvez plus sélectionner d\'annonces.',
      overMessageQuota: 'Attention vous avez sélectionné plus d\'annonces que le quota autorisé.',
      adsSelection: 'Sélection des annonces',
      adsSelectionText: 'Cochez les annonces que vous souhaitez diffuser sur le portail',
      backProgram: 'Retour programme',
      columnSent: 'Diffusée',
      columnSelected: 'Sélection',
      columnPicture: 'Photo',
      columnReference: 'Référence',
      columnCity: 'Ville',
      columnPrice: 'Prix',
      columnActions: 'Actions',
      priceContactUs: 'Nous consulter',
      confirmSelectionDeactivation: 'Êtes-vous certain de vouloir désactiver votre sélection d\'annonces ?',
      confirmSelectionDeactivationTitle: 'Désactiver la diffusion',
      deactivated: 'Désactiver',
      confirmSelectionDiffusion: 'Êtes-vous certain de vouloir diffuser les annonces sélectionnées ?',
      confirmSelectionDiffusionTitle: 'Diffuser ces annonces',
      broadcast: 'Diffuser',
      messageSuccessDeactivation: 'Votre demande de désactivation a bien été prise en compte.',
      messageSuccessDiffusion: 'Votre demande de diffusion d\'annonces a bien été prise en compte.'
    },
    list: {
      diffuseMyAds: 'Diffuser mes annonces',
      showAllPortals: 'Afficher tous les portails',
      returnToDiffusions: 'Retour à la liste des diffusions',
      activationToPaidPortalTitle: 'Activation de la diffusion vers {{ portal }}',
      activationToPaidPortalText: 'Cet abonnement est payant.' +
                                  '<br/><br/>Veuillez prendre contact avec ce portail pour vous abonner, en indiquant que ' +
                                  'vous êtes également client Ubiflow pour la diffusion de vos annonces.' +
                                  '<br/><br/>Une fois votre abonnement validé, Ubiflow recevra les informations techniques et ' +
                                  'mettra en place la diffusion vers ce portail.' +
                                  '<br/><br/>Voici le contact commercial du portail : {{ email }}<br/>',
      activationResultTitle: "Résultat de l'activation de la diffusion",
      activateUbiflowPackageTitle: 'Activer le bouquet Ubiflow',
      activateUbiflowPackageText: 'Vous êtes sur le point d\'activer la diffusion de vos annonces sur l\'intégralité ' +
                                  'du bouquet visibilité Ubiflow, souhaitez-vous valider cette activation ?',
      deactivateDiffusionTitle: 'Désactivation de la diffusion',
      deactivateDiffusionText: 'Êtes-vous sûr de vouloir désactiver la diffusion sur ce portail ?',
      deactivateDiffusionConfirmation: 'La diffusion client a été désactivée.',
      pushToTopOfListTitle: 'Remontée en tête de liste des annonces',
      activationResultUbiflowPackageTitle: "Résultats de l'activation du bouquet",
      activationResultUbiflowPackageAdded: 'Voici les diffusions ajoutées à votre liste de portail',
      activationResultUbiflowPackageRemoved: 'Les diffusions vers les portails indiqués ci-dessous ont récemment été désactivées de notre portail',
      activationResultUbiflowPackageMessage: 'Le bouquet Ubiflow évolue et acceuille des nouveaux portails en continue. ' +
                                             "A chaque notifiaction d'ajout d'un portail, cliquez de nouveau sur le bouton " +
                                             '´Activez le bouquet Ubiflow´ et diffusez plus largement.',
      impossibleToActiveModalTitle: 'Activation de la diffusion vers le portail : ',
      impossibleToActiveModalText: 'Pour mettre en place votre diffusion vers ce portail, veuillez le contacter directement svp.\n' +
                                    'Voici les coordonnées de l\'équipe commerciale du portail :',
      mail: 'Email',
      tel: 'Tél',
      confirm: 'Confirmer',
      cancel: 'Annuler',
      close: 'Fermer',
      result: 'Résultat',
      pushToTopOfList: 'Remonter en tête de liste',
      exportResults: 'Exporter les résultats',
      export: 'Exporter',
      forSelection: 'Pour la sélection',
      results: 'Résultats',
      columnActivate: 'Activée',
      columnLogo: 'Logo',
      columnPortal: 'Portail',
      columnAds: 'Annonces',
      columnLastDiffusion: 'Dernier envoi',
      columnSelectAds: 'Sélectionner mes annonces',
      columnActions: 'Actions',
      columnDiffused: 'Diffusée',
      columnPicture: 'Photo',
      columnReference: 'Référence',
      columnCity: 'Ville',
      columnPrice: 'Prix',
      columnEditDiffusion: 'Gérer ma diffusion',
      columnMyPortal: 'Mon portail',
      columnCategory: 'Catégorie',
      columnSelectionType: 'Type de sélection',
      columnContacts: 'Contacts',
      columnProspects: 'Prospects',
      columnPublication: 'Envoyée le',
      actionReport: 'Rapport de diffusion',
      actionSuspend: 'Suspendre la diffusion',
      actionActivate: 'Activer la diffusion',
      buttonAds: 'Annonces',
      buttonActivate: 'Activer',
      goBackToDiffusionList: 'Retour à la liste des diffusions',
      deactivateDiffusion: 'Désactiver la diffusion',
      activateDiffusion: 'Activer la diffusion',
      noSelectionWarning: 'Veuillez sélectionner au moins un portail',
      portalSelection: "Sélection des portails sur lesquels diffuser l'annonce",
      portalSelectionActivateDiffusionTitle: 'Activer la diffusion pour cette sélection de portails',
      portalSelectionActivateDiffusionText: 'Confirmer la sélection ?',
      portalSelectionDeactivateDiffusionTitle: 'Désactiver la diffusion pour cette sélection de portails',
      portalSelectionDeactivateDiffusionText: 'Désactiver la sélection ?',
      portalSelectionDeactivationConfirmationTitle: 'Désactivation de la diffusion',
      portalSelectionDeactivationConfirmationText: 'La diffusion de votre annonce a bien été désactivée.',
      dateLastDiffusion: 'Date de dernière diffusion',
      noDiffused: 'Non diffusée',
      numberOfSelectedPortals: 'Nombre de portails sélectionnés',
      numberOfSelectedPrograms: 'Nombre de programmes sélectionnés',
      filenameExportDiffusions: 'diffusions',
      filenameExportAdsSelection: 'selection_annonces',
      filenameExportPortals: 'liste_portails',
      dialogPushToTopOfListTitle: 'Remontée en tête de liste des annonces',
      dialogPushToTopOfListTextSuccess: 'Vos annonces seront remontées dans les premières places sur les portails sélectionnés ' +
          'et le permettant dès la prochaine diffusion.',
      dialogPushToTopOfListTextLimit: 'Vous ne pouvez utiliser cette fonctionnalité qu\'une fois par semaine. Merci.',
      dialogPushToTopOfListButtonConfirm: 'Confirmer',
      dialogPushToTopOfListButtonClose: 'Fermer',
      dialogEditPostQuota: 'Modification du statut de diffusion vers',
      dialogEditIdentifiants: 'Modification des identifiants éditables',
      champObligatoire: 'Champ obligatoire',
      aucunIdentifiantEditable: 'Aucun identifiant éditable pour ce portail',
      doNotBroadcast: 'Ne pas diffuser',
      unlimited: 'Illimité',
      limitedToXPosts: "Limite d'annonces",
      contactBroadcasterToEditQuota: 'Pour modifier votre statut de diffusion vers ce portail, veuillez le contacter directement.',
      limitedTo: 'Limité à',
      editQuota: 'Modifier le quota',
      editIdentifiants: 'Modifier / Renseigner les identifiants',
      immowebUrlConnexion: 'Connexion espace Immoweb',
      selogerUrlConnexion: 'Autoriser Ubiflow a diffuser sur les sites du groupe Seloger',
      selectedAds: 'Annonces sélectionnées',
      diffusedAds: 'Annonces diffusées',
      quotaPerso: 'Quota personnel',
      statutDIff: 'Quota',
      chargementDonnees: 'Nous chargeons vos données, encore un peu de patience ;)',
      validateLotsDiffusionBailleur: 'Vous vous apprêtez à diffuser des annonces et/ou des programmes. En cochant cette case vous confirmez que tous les lots associés au(x) programme(s) sélectionné(s) soient également diffusés. Si vous ne le souhaitez pas, décochez les programmes concernés puis sélectionnez manuellement les lots à diffuser depuis la page "Voir les lots".', // To translate,
      nbLotsBroadcasted: 'Nombre de lots diffusés',
      validateLotsDiffusion: 'Vous vous apprêtez à diffuser un nouveau programme. Souhaitez-vous que l\'ensemble des lots ' +
          'associés soit également diffusés ? Si non, vous pourrez sélectionner manuellement vos annonces depuis le ' +
          'bouton "voir les lots".',
      noDiffusionTitle: 'Diffusion',
      noDiffusionText1: "Cette fonctionnalité n'est pas activée dans votre abonnement",
      noDiffusionText2: 'POURQUOI ACTIVER LE PRODUIT DE DIFFUSION UBIFLOW ?',
      noDiffusionText3: "La diffusion avec Ubiflow, c'est vous donner les moyens de <strong>personnaliser, enrichir, mesurer et " +
          'envoyer</strong> vos annonces sur les supports web avec encore plus de pertinence. <br><br> ' +
          'Que vous gériez vos annonces depuis un outil tiers (logiciel, site Internet, CRM), ou qu\'elles ' +
          'soient créées depuis notre outil de saisie d\'annonces, assurez en toute autonomie la diffusion de vos annonces.',
      noDiffusionText4: 'GAIN DE TEMPS',
      noDiffusionText5: 'Envoyez vos annonces partout sur les différents portails en <strong>1 clic.</strong> Depuis 1 seul et unique ' +
          'endroit, votre Espace Client ! Fini les multiples comptes sur lesquels vous connecter et difficulté ' +
          'd\'appréhender chacun des outils mis à votre disposition. <strong>Un gain de temps non négligeable !</strong> ',
      noDiffusionText6: 'PERSONNALISATION DE VOTRE DIFFUSION',
      noDiffusionText7: 'Gérez la diffusion de vos annonces de manière groupée ou personnalisée ! <br>' +
          'Une excellente pratique pour viser la <strong>bonne audience</strong>, sur le bon support et au bon moment en ' +
          'fonction de votre stock d\'annonces.',
      noDiffusionText8: 'SUIVRE VOTRE PRÉSENCE SUR LES PORTAILS',
      noDiffusionText9: '<strong>Suivez la diffusion de vos annonces</strong> grâce à nos rapports de diffusion et de présence mis à ' +
          'votre disposition. Nous identifions ainsi rapidement les points bloquants et les raisons afin ' +
          'd\'intervenir dans les meilleurs délais. Ne vous occupez de rien ! Notre équipe prend contact avec ' +
          'les portails concernés.',
      noDiffusionText10: 'CALCULER VOTRE ROI ET GÉRER VOTRE BUDGET',
      noDiffusionText11: 'Notre outil de diffusion couplé à notre solution de gestion de contacts',
      noDiffusionText12: 'vous permet d\'identifier les portails sur lesquels vos annonces sont <strong>le plus ' +
          'visitées</strong> et qui <strong>génèrent le plus de contact. Optimisez ainsi vos coûts de diffusion !</strong>',
      noDiffusionText13: '24 options viennent enrichir notre produit de diffusion, dont la plupart sont incluses par défaut : ' +
          'diffusion sélective, personnalisation des coordonnées indiquées sur vos annonces, remontée en tête ' +
          'de liste, outil de saisie, multi-émetteur, …',
      reconciliationRequests: 'Demandes de rapprochement',
      TextReconciliation: 'Il s\'agit des demandes adressées par les internautes sur un portail mais qui ne fait pas référence à une annonce en particulier. Une notification mail vous est envoyée en parallèle pour les sites le permettant. Ces contacts ne sont pas comptabilisés dans le nombre de contacts générés au total.\n',
      selogerMessaqeAuthorisationOk: '<div>Vous avez autorisé Ubiflow à diffuser sur les sites du groupe Seloger.</div>\n<div>Notre relation client a été averti, merci.</div>',
      selogerMessaqeAuthorisationKo: 'Erreur de chargement sur cette page'
    },
    report: {
      globalTitle: 'Statistiques générales',
      title: 'Statistiques de diffusion sur le portail',
      quota: 'Quota',
      quotaAds: 'annonces',
      quotaUnlimited: 'Illimité',
      selectedAds: 'annonces sélectionnées',
      selectionMode: 'Mode de sélection des annonces',
      lastDiffusion: 'Dernier envoi',
      adsDiffused: 'annonces diffusées',
      filter: "'Filtrer les annonces par référence...",
      selected: 'Sélectionnées',
      diffused: 'Diffusées',
      published: 'Publiées',
      exportResults: 'Exporter les résultats',
      exportResultsWithoutContact: 'Export annonces sans contact',
      columnStatus: 'Statut',
      columnAd: 'Annonce',
      columnReference: 'Référence',
      columnDateCreation: 'Date de création',
      columnDateModification: 'Date de modification',
      columnPictures: 'Nb. photos',
      columnDateDiffused: 'Date de mise en ligne',
      columnLogo: 'Logo',
      columnPortal: 'Portail',
      columnDateDiffusion: 'Date de diffusion',
      columnAdsDiffused: 'Annonces diffusées',
      statusError: 'Erreur',
      statusPublished: 'Publiée',
      statusDiffused: 'Diffusée',
      statusIgnored: 'Ignorée',
      convertDateBeginning: 'Le {{ date }}',
      lastUpdateAds: 'Dernière mise à jour des annonces',
      activePortals: 'Portails actifs',
      globalAdsDiffused: 'Annonces diffusées',
      detailedReportsPortalByPortal: 'Les rapports en erreurs détaillés',
      noMessage: 'Aucun message',
      filenameExportDiffusion: 'export_rapport_diffusion'
    },
    optimizeBroadcast: {
      pub: 'Optimisez votre budget publicitaire sur les portails d\'annonces en définissant vous-même la priorité que vous souhaitez donner à la diffusion de vos annonces. Si vous souhaitez mettre en place une autre règle de diffusion',
      contactUs: 'contactez-nous',
      activeRule: 'Règle active',
      noActiveRule: 'Aucune règle active',
      activeRuleNbPortals: 'Sur <strong>{{ portalsCount }} portail(s)</strong>',
      activeRulePortals: 'Accès à la liste des portails sur lesquels la règle est appliquée',
      rulesColumnActive: 'Actif',
      rulesColumnLabel: 'Règle de priorité',
      rulesColumnActions: 'Actions',
      rulesColumnPortals: 'Liste de portails',
      validationSelection: 'La règle de sélection à été mise à jour',
      speRule: 'Règle personnalisée',
      spePortals: 'Sur le(s) portail(s)',
      nonEligibleTitle: 'ACTIVATION D\'UNE RÈGLE DE DIFFUSION DES ANNONCES',
      nonEligibleTexte: '<p>Votre offre actuelle ne vous permet pas d\'activer une des règles de notre catalogue.</p>' +
          '<p>Pas de panique, nous pouvons malgré tout répondre à votre besoin. Pour activer une règle de diffusion de vos annonces, demandez à être recontacté par notre équipe en cliquant sur le bouton ci-dessous.</p>' +
          '<p>Le saviez-vous ? Nous pouvons étudier avec vous la mise en place d\'une règle entièrement personnalisée et adaptée à votre besoin.</p>',
      noCompatiblePortalTitle: 'AUCUN PORTAIL COMPATIBLE',
      noCompatiblePortalTexte: '<p>Votre offre vous permet d\'activer une règle de priorité de diffusion. En revanche, aucun de vos portails n\'est actuellement compatible.</p>' +
          '<p>Un portail est compatible lorsqu\'il utilise le moteur de sélection V2 et qu\'il n\'est pas déjà rattaché à une règle personnalisée.</p>',
      newRuleTitle: 'ACTIVATION D\'UNE NOUVELLE RÈGLE',
      newRuleTexte1: 'Pour activer une nouvelle règle de diffusion et ainsi personaliser vos ordres de diffusion d\'annonces, demandez à être recontacté par notre équipe en cliquant sur le bouton ci-dessous.',
      newRuleTexte2: 'Vous avez également la possibilité d\'activer une nouvelle règle de diffusion en désélectionnant la précédente.',
      contact: 'Je souhaite être recontacté',
      cancel: 'Annuler',
      listPortalsTitle: 'GESTION DE VOTRE LISTE DE PORTAILS',
      listPortalsTexte: 'Sélectionnez les portails pour lesquels vous souhaitez appliquer la règle de priorité.',
      listPortalsTexte2: 'Vous pouvez modifier à tout moment cette sélection.',
      listPortalsTexte3: 'Un ou plusieurs portails n\'apparaissent pas ? Peut être n\'avez-vous pas renseigné son quota, élément obligatoire à la mise en place de la règle de priorisation de la diffusion. ' +
          'Pour indiquer ces quotas, vous pouvez le faire depuis la rubrique "Diffusion", puis "Modifier le quota" dans la colonne "Actions".',
      listPortalsWarnTitle: 'ATTENTION !',
      listPortalsWarnTexte: 'Si les règles de publication des portails sélectionnés ne sont pas compatibles avec la règle de priorisation que vous avez choisie, nous ne pouvons garantir la bonne diffusion de vos annonces sur les portails concernés.',
      listPortalsAction: 'Valider ma sélection',
      messageSendMail: 'Votre demande a bien été envoyé à notre équipe. Vous serez recontacté très bientôt.',
      messagePortalV1: 'Ce portail n\'est pas encore compatible avec la règle de diffusion. Vous pouvez contacter notre service client au 02 30 95 20 00 / relation.client@ubiflow.net pour finaliser sa configuration.',
      messagePortalUsed: 'Ce portail est déjà utilisé pour une règle spécifique et ne peut être sélectionné.'
    }
  },
  users: {
    edit: 'Éditer',
    addUser: 'Ajouter un utilisateur',
    import: 'Importer',
    importSuccess: '{{created}} utilisateur(s) créé(s), {{updated}} mis à jour.',
    importRejectedLine: 'Ligne {{line}} : {{reason}}',
    importError: "Le fichier n'a pas pu être importé",
    search: 'Recherche',
    searchPlaceholder: 'Nom ou email',
    fullName: 'Prénom et nom',
    columnStatus: 'Statut',
    columnActions: 'Actions',
    detailTitle: "Détail de l'utilisateur",
    viewDetail: 'Voir le détail',
    delete: 'Supprimer',
    deleteConfirm: 'Voulez-vous vraiment supprimer cet utilisateur ?',
    username: "Nom d'utilisateur",
    statusFilter: 'État du compte',
    role: 'Rôle',
    rolePlaceholder: 'Choisir un rôle...',
    userPlaceholder: 'Sélectionner un utilisateur...',
    contactPlaceholder: 'Sélectionner un contact...',
    lastname: 'Nom',
    firstname: 'Prénom',
    email: 'Email',
    phone: 'Téléphone',
    mobile: 'Mobile',
    address: 'Adresse',
    postalCode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    price: "Tarifs de l'utilisateur",
    placeholderPrice: "Indiquer l'url des tarifs de l'agence",
    cancel: 'Annuler',
    confirm: 'Confirmer',
    requiredHint: 'Les champs marqués * sont obligatoires.',
    sectionAccount: 'Compte',
    close: 'Fermer',
    sectionIdentity: 'Identité',
    sectionContact: 'Coordonnées',
    optional: 'optionnel',
    sectionAccess: 'Accès Espace Client',
    accessContactOnly: 'Contact seul',
    accessContactOnlyHint: 'Fiche sans connexion',
    accessSpace: 'Accès Espace Client',
    accessSpaceHint: 'Administrateur ou utilisateur',
    accessPendingNote: "La demande est transmise à l'équipe Ubiflow. Le compte est créé inactif.",
    createUserSubmit: "Créer l'utilisateur",
    saveUser: 'Enregistrer',
    createNewUser: 'Créer un nouvel utilisateur',
    editUser: "Éditer l'utilisateur",
    messageCreate: "L'utilisateur à bien été créé",
    messageCreateAccess: 'Votre demande a bien été prise en compte. Notre équipe prendra contact avec vous dans les ' +
          "meilleurs délais pour définir ensemble les différentes modalités d'accès",
    messageUpdate: "L'utilisateur a bien été mis à jour",
    messageDelete: "L'utilisateur vient d'être supprimé",
    messageError: 'Une erreur a été rencontrée',
    forSelection: 'Pour la sélection',
    export: 'Exporter',
    exportAll: 'Tout exporter',
    listMode: 'Mode Liste',
    vignetteMode: 'Mode vignette',
    enabled: 'Activé',
    disabled: 'Désactivé',
    actionsOnThisUser: 'Actions sur cet utilisateur',
    logIn: 'Se connecter',
    allUsers: 'Tous les utilisateurs',
    activeUsers: 'Utilisateurs actifs',
    activeUsersQuota: 'Utilisateurs actifs : {{count}} / {{quota}}',
    inactiveUsers: 'Utilisateurs non actifs',
    confirmationMessage: "Vous allez être redirigé sur l'Espace Client d'un collaborateur rattaché à votre compte.",
    caution: 'Attention',
    mailSended: 'Les instructions de création de compte lui ont été envoyées par mail',
    createAccess: "Souhaitez-vous créer un accès à l'Espace Client à ce nouveau contact ?",
    mainAccount: 'Compte principal',
    contact: 'Contact',
    admin: 'Administrateur',
    user: 'Utilisateur'
  },
  profile: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    myPersonalInformation: 'Mes informations personnelles',
    lastname: 'Nom',
    firstname: 'Prénom',
    email: 'Email',
    phone: 'Téléphone',
    agencyInformation: "Les informations de l'agence",
    corporateName: 'Raison sociale',
    companyName: 'Nom de la société',
    address: 'Adresse',
    postalCode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    fax: 'Fax',
    website: 'Site web',
    price: "Tarifs de l'utilisateur",
    placeholderPrice: "Indiquer l'url des tarifs de l'agence",
    logo: 'Logo',
    uploadTip: 'Fichiers jpg/jpeg/png/webp/avif avec une taille inférieure à 2Mo',
    activateAdsToTopFunctionality: 'Activer la gestion manuelle des remontées en tête de liste de vos annonces sur les portails compatibles.',
    messageSuccess: 'Les paramètres ont été mises à jour',
    messageSuccessAgency: "Les paramètres de l'agence ont été mise à jour",
    messageError: "Une erreur s'est produite",
    saveFilters: 'Conserver mes filtres de recherche après ma déconnexion',
    Configurations: 'Configurations autres',
    saveFiltersTitle: 'Configuration de la recherche sur mon Espace Client Ubiflow',
    activateAdsToTopFunctionalityTitle: 'Configuration des remontées en tête de liste',
    soldProductMaskColorTitle: 'Configuration de la couleur des bandeaux biens vendus'
  },
  exports: {
    description: 'Vos fichiers seront disponibles ici pendant deux semaines à partir de la date de l\'export.',
    removeTitle: 'Supprimer votre fichier',
    removeText: 'Etes-vous sûr de vouloir supprimer votre fichier ?',
    removeSuccess: 'Votre fichier a bien été supprimé.',
    multipleRemoveSuccess: 'Vos fichiers ont bien été supprimés.'
  },
  general: {
    yes: 'Oui',
    no: 'Non',
    month: 'mois',
    year: 'an',
    week: 'semaine',
    exitConfirmation: 'Voulez-vous vraiment quitter ?',
    ubiflowWebsite: 'Ubiflow.net',
    calendar: {
      socialManagment: 'Adoptez une stratégie Social Media ',
      planningSubtitle: 'Souscrivez à l\'offre Social Manager + pour accéder à un outil complet de gestion de votre présence sur les réseaux sociaux et optimiser votre référencement local :',
      planning: 'Gestion de la planification',
      changeTheSchedule: 'Modifier la planification',
      lastWeek: 'Semaine dernière',
      lastMonth: 'Mois dernier',
      lastThreeMonths: '3 derniers mois',
      lastSixMonths: '6 derniers mois',
      lastTwelveMonths: '12 derniers mois',
      slogan1: 'Accès au calendrier de planification de vos posts',
      slogan2: 'Création et gestion de votre fiche Google',
      slogan3: 'Présence sur 16 médias (Google, Facebook, Waze, Plans...)',
      slogan4: 'Gestion de votre communication sur Facebook et Google Business Profil',
      slogan5: 'Génération des posts grâce à l\'IA',
      slogan6: 'Gestion des avis déposés et réponses automatisées grâce à l\'IA',
      slogan7: 'Gestion des questions/réponses déposées sur Google',
      slogan8: 'Accès aux données statistiques',
      planningDate: 'Date de publication',
      spreadOn: 'Diffusé sur',
      scheduled: 'Planifier',
      publishNow: 'Publier maintenant',
      edit: 'Modifier',
      delete: 'Supprimer',
      postNoPlanned: 'Post non planifié',
      postPublished: 'Post publié',
      postPlanned: 'Post planifié',
      postAlreadyPlanned: 'Post déjà publié',
      acceptedPost: 'Accepter',
      refusedPost: 'Refuser',
      planningPost: 'Planification',
      publishingPost: 'Publication',
      areYouSureYouWantToPublishYourPost: 'Êtes vous sûr de vouloir publier votre post ?',
      areYouSureYouWantToPlanYourPost: 'Êtes vous sûr de vouloir planifier votre post ?',
      thePostWasPlanned: 'Le post a été planifié.',
      thePostWasPublished: 'Le post a été publié.',
      ThePlanningWasUnsuccessful: 'La planification a échouée.',
      ThePublicationWasUnsuccessful: 'La publication a échouée.',
      TheCurrentScheduleHasBeenCanceled: 'La planification en cours a été annulée.',
      TheCurrentPublicationHasBeenCanceled: 'La publication en cours a été annulée.',
      deletionHasBeenUndone: 'La suppression a été annulée.',
      deletionHasBeenCompleted: 'La suppression a été effectuée.',
      theChangeHasBeenMade: 'La modification a été effectuée.',
      theChangeHasBeenUndone: 'La modification a été annulée.',
      areYouSureYouWantToDeleteYourSchedule: 'Êtes-vous sûr de vouloir supprimer votre planification ?',
      areYouSureYouWantToDeleteYoursScheduleSelected: 'Êtes-vous sûr de vouloir supprimer vos planifications selectionnées {{refsUniquesSelection}} ?',
      areYouSureYouWantToChangeYourSchedule: 'Êtes-vous sûr de vouloir modifier votre planification ?',
      warningSheduledBefore: 'Votre planification ne peut être exécutée car elle est antérieure à la date d\'aujourd\'hui.',
      deletionFailed: 'La suppression a échouée.',
      deletionPost: 'Suppression',
      Amendment: 'Modification',
      deleteSchedule: 'Supprimer la planification',
      mailSubjectSocialManagmentPlus: 'Nouvelle demande d\'information sur l\'offre Social Manager + depuis l\'Espace Client',
      emailContentSocialManagmentPlus: 'Bonjour, Une nouvelle demande de renseignement a été faite depuis l\'Espace client pour le pack Social Manager +' +
          ' par l\'annonceur {{advertiser}} ({{companyName}}) . Vous pouvez le recontacter ' +
          ' via {{email}} ou au numéro {{phoneNumber}}' +
          ' Merci. Bonne journée.',
      emailSendSuccess: 'Votre email a été envoyé avec succès.',
      loaderMessageCalendar: 'Patience ! Le chargement de vos données est en cours, cela peut prendre quelques secondes.',
      featureForbidden: 'Fonctionnalité non disponible'
    },
    sort: {
      date: 'Date',
      decreaseDate: 'Date décroissante',
      increaseDate: 'Date croissante',
      reference: 'Référence',
      title: 'Titre',
      name: 'Nom',
      lastDiffusion: 'Date de dernier envoi',
      datePublication: 'Date de mise en ligne',
      ads: 'Annonces',
      contacts: 'Contacts',
      dateCreation: 'Date de création',
      contactEmail: 'Contacts mail',
      contactTel: 'Contacts tel.',
      contactName: 'Nom contact',
      callDurationDecrease: 'Durée appel décroissante',
      callDurationIncrease: 'Durée appel croissante',
      callNumber: 'N° téléphone',
      portalName: 'Nom portail',
      creationDate: 'Date de création'
    },
    selection: {
      forSelection: 'Pour la sélection',
      exportAll: 'Tout exporter',
      export: 'Exporter',
      activateDeactivate: 'Activer/Suspendre',
      changeContact: 'Editer le contact',
      activeAds: 'Annonces actives',
      inactiveAds: 'Annonces désactivées',
      download: 'Télécharger',
      remove: 'Supprimer',
      validate: 'Valider'
    },
    filters: {
      adType: "Type d'annonce",
      allAds: 'Toutes les annonces',
      allPrograms: 'Tous les programmes',
      allLots: 'Tous les lots',
      activeAds: 'Annonces activées',
      inactiveOrDraftAds: 'Annonces désactivées ou en brouillon',
      withoutPictures: 'Annonces sans photos',
      diffusedAds: 'Annonces diffusées',
      noDiffusedAds: 'Annonces non diffusées',
      diffusionAll: 'toutes',
      diffusionYes: 'annonces diffusées',
      diffusionNo: 'annonces non diffusées',
      diffusion: 'Diffusion',
      modelAds: 'Annonces modèles',
      stockSelection: 'Choix du stock',
      stockSelectionPlaceholder: 'Choisir un stock',
      brand: 'Marque',
      brandPlaceholder: 'Choisir une marque',
      model: 'Modèle',
      models: 'Modèles',
      modelPlaceholder: 'Choisir un modèle',
      openSearch: 'Chercher par ville, titre, référence',
      openSearchPlaceholder: 'Recherche',
      searchByReference: 'Recherche par référence',
      offerType: "Type d'offre",
      offerTypePlaceholder: 'Choisir un type',
      portalsSelection: 'Portails',
      programType: 'Type de programme',
      programTypeLand: 'Terrains',
      programTypeLandHouse: 'Programme terrain + maison',
      propertyType: 'Type de logement',
      propertyTypeVo: 'Type de véhicule',
      mandateType: 'Type de mandat',
      mandateTypeSimple: 'Simple',
      mandateTypeExclusive: 'Exclusif',
      mandateTypeSemiExclusive: 'Semi-exclusif',
      date: 'Chercher par date',
      dateCreation: 'Date de création',
      dateDiffusion: 'Date de diffusion',
      datePublication: 'Date de mise en ligne',
      dateCreationStart: 'A partir du...',
      dateCreationEnd: "jusqu'au...",
      name: 'Nom',
      surface: 'Surface : entre {{ surfaceGt }}m² et {{ surfaceLt }}m²',
      vehicleYear: 'Millésime',
      priceMin: 'Prix min',
      priceMax: 'Prix max',
      tooltipContactList: 'Afin que tous vos contacts apparaissent dans la liste ci-dessous, assurez-vous d\'avoir renseigné leur nom et prénom dans le carnet de contact.',
      title: 'Chercher par titre',
      titleReference: 'Chercher par titre, référence',
      titleReferenceCity: 'Chercher par titre, référence, ville',
      portalName: 'Chercher par nom de portail',
      titlePlaceholder: 'Recherche...',
      portalCategory: 'Catégorie de portail',
      portalCategoryPlaceholder: 'Toutes catégories',
      businessModel: 'Modèle économique',
      businessModelFree: 'Gratuit',
      businessModelPaid: 'Payant',
      quota: "Quota d'annonces",
      quotaWith: 'Avec quota',
      quotaWithout: 'Sans quota',
      portals: 'Portails',
      allPortals: 'Tous les portails',
      activePortals: 'Portails actifs',
      inactivePortals: 'Portails inactifs',
      onlySelectedPortals: 'Uniquement les portails sélectionnés',
      onlyNoSelectedPortals: 'Uniquement les portails non-sélectionnés',
      adReference: "Référence de l'annonce",
      adReferencePlaceholder: 'Recherche...',
      integratedAds: 'Annonces intégrées',
      warningAds: 'Avertissement',
      errorAds: 'Annonces rejetées',
      noPictureAds: 'Annonces sans photos',
      adsWithContacts: 'Annonces avec contacts',
      adsWithoutContacts: 'Annonces sans contact',
      onlyActiveAds: 'Uniquement annonces actives',
      freePortals: 'Portails gratuits',
      paidPortals: 'Portails payants',
      portalsWithoutContact: 'Portails sans contact',
      portalsWithContacts: 'Portails avec contacts',
      allContacts: 'Tous les contacts',
      name: 'Chercher par nom',
      referenceContactEmail: 'Chercher par référence, contact, ou mail',
      portalContactEmail: 'Chercher par nom portail, contact, ou mail',
      phoneNumber: 'Chercher par numéro de téléphone',
      callStatus: "Statut de l'appel",
      callAnswered: 'Appel pris',
      callMissed: 'Appel manqué',
      all: 'Tous',
      typeLandHouse: 'Programme terrain + maison',
      resetFilters: 'Réinitialiser les filtres',
      deletedPosts: 'Annonces supprimées',
      socialNetworks: 'Réseaux sociaux',
      soldPosts: 'Biens vendus',
      marchandVo: 'Marchand VO',
      marchandVoPlaceholder: 'Choisir un marchand VO',
      energie: 'Énergie',
      energiePlaceholder: 'Choisir une énergie',
      kilometrageMin: 'Kilométrage min',
      kilometrageMax: 'Kilométrage max',
      achatvo: 'Achat',
      achatvoPlaceholder: '(Lot ou à l\'unité)',
      achatLot: 'Lot',
      achatUnite: 'À l\'unité',
      annoncesValides: 'Annonces validées',
      annoncesNonValides: 'Annonces non validées',
      negociateur: 'Chercher par mandataire',
      negociateurPlaceholder: 'Recherche...',
      filter: 'Filtre',
      portalType: 'Type de portail',
      hasFilledQualificationForm: 'A rempli un formulaire de qualification',
      price: 'Prix',
      from: 'à partir de',
      upTo: 'jusqu\'à',
      selected: 'sélectionné',
      notSelected: 'non sélectionné',
      more: 'Plus',
      managePinnedFilters: 'Gérer les filtres épinglés',
      pinnedFiltersExplanation: 'Choisissez les filtres à afficher en permanence dans la barre de tags. Les autres seront accessibles via le bouton "Gérer les filtres épinglés".',
      //  Traductions ajoutées pour les fixtures
      archived: 'Annonces archivées',
      terrain: 'Terrain',
      lotType: 'Type de lot',
      dateStart: 'Date début',
      dateEnd: 'Date fin',
      min: 'Min',
      max: 'Max',
      user: 'Utilisateur',
      contact: 'Contact',
      contactAAfficher: 'Contact à afficher'
    },

    //  Nouvelle section stocks
    stocks: {
      main: 'Stock principal',
      secondary: 'Stock secondaire'
    },

    //  Nouvelle section mandates
    mandates: {
      all: 'Tous',
      simple: 'Simple',
      exclusive: 'Exclusif',
      semiExclusive: 'Semi-exclusif'
    },

    //  Nouvelle section diffusion
    diffusion: {
      broadcast: 'Diffusées',
      notBroadcast: 'Non diffusées'
    },

    //  Traductions générales
    resetFilters: 'Réinitialiser les filtres',
    search: 'Rechercher',
    hide: 'Masquer',
    show: 'Afficher'
  },
  planning: {
    calendar: 'Calendrier',
    backToCalendar: 'Retour au calendrier',
    title: 'Gestion de la planification',
    day: 'Jour',
    today: 'Aujourd\'hui',
    week: 'Semaine',
    month: 'Mois',
    jour4: '4 Jours',
    beContacted: 'Intéressé par ce produit? Être contacté par un conseiller commercial.',
    searchByTitle: 'Chercher par titre, référence',
    searchPlaceholder: 'Recherche',
    typePost: 'Type de contenu',
    network: 'Réseau social',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    choiceTypePost: 'Choississez par type de contenu',
    all: 'Tous les posts',
    instagram: 'Instagram',
    facebook: 'Facebook',
    gmb: 'GMB',
    linkedin: 'Linkedin',
    dialogMessage: 'Vous souhaitez des informations sur notre produit Social Manager +. Notre équipe va prendre contact avec vous dans les meilleurs délais',
    postsAds: 'Posts d\'annonces',
    postsBv: 'Biens vendus',
    postsEdito: 'Posts éditoriaux',
    searchByMonth: 'Chercher par mois',
    selectedMonth: 'Sélectionnez un mois',
    postsList: 'Liste des posts',
    forSelection: 'Pour la selection ({{ selectedNumber }}):',
    resultsOfTheDate: 'Résultat(s) de la date du',
    exportPlanning: 'Export de la planification du {{ date }}',
    messageInfoDeleted: 'Certaines planifications ne sont pas supprimées car elles ont été générées en automatique.',
    deletionInformation: 'Information sur les suppressions',
    contentInfoBox: 'Attention, les posts qui sont déjà publiés ne peuvent en aucun cas être supprimés.',
    titleAds: 'Titre de l\'annonce',
    pictures: 'Photos',
    publishOn: 'Publié sur',
    date: 'Date',
    status: 'Statut'
  },
  socialPosts: {
    list: {
      postAnnonces: 'Posts d\'annonces',
      biensVendus: 'Posts de biens vendus',
      postsEditoriaux: 'Posts éditoriaux',
      publishOn: 'Publié sur',
      publishedOn: 'Publié le',
      actions: 'Actions',
      noSubscription: '<h3>Une stratégie réseaux sociaux complète, 100% automatisée</h3>' +
          '<p>Ne choisissez plus entre valoriser vos biens et animer votre communauté. Notre solution assistée par IA prend tout en charge pour vous garantir une image de marque irréprochable :</p>' +
          '<ul>' +
          '<li><strong>Génération &amp; Diffusion d\'annonces :</strong> Vos annonces sont automatiquement transformées en posts attractifs et diffusées sur vos réseaux pour valoriser votre portefeuille.</li>' +
          '<li><strong>Contenus éditoriaux clés en main :</strong> L\'IA crée pour vous des publications variées (conseils, actualités du secteur, vie de l\'entreprise) pour affirmer votre expertise.</li>' +
          '<li><strong>Régularité &amp; Qualité :</strong> Assurez une présence en ligne constante et professionnelle sans y passer des heures.</li>' +
          '</ul>' +
          '<p>Prêt(e) à automatiser votre communication ? Cliquez ci-dessous pour qu\'un conseiller Ubiflow vous recontacte et active votre option.</p>',
      viewOnly: 'Voir l\'annonce'
    },
    planification: {
      title: 'Planifier vos posts',
      instruction: 'Choisissez quand publier votre contenu sur chacun des réseaux sociaux sélectionnés.',
      selectDateTime: 'Sélectionnez date et horaire',
      publishNow: 'Ou publier maintenant',
      alreadyPublishedFacebook: 'Votre post a déjà été diffusé sur Facebook',
      alreadyPublishedInstagram: 'Votre post a déjà été diffusé sur Instagram',
      alreadyPublishedGoogle: 'Votre post a déjà été diffusé sur Google',
      alreadyPublishedLinkedin: 'Votre post a déjà été diffusé sur LinkedIn',
      apply: 'Appliquer mes choix de publication'
    },
    scheduledAt: 'Planifié le',
    sentAt: 'Envoyé le',
    models: {
      title: 'Ma bibliothèque de modèles de posts',
      header: 'Pour créer un nouveau post à partir d\'un modèle, vous pouvez sélectionner un modèle parmi la liste ci-dessous en cliquant sur « Utiliser ».\n' +
        '<br><br>' +
        'Depuis le formulaire d\'édition du post, vous aurez la possibilité de modifier son contenu, texte, et média mais aussi de gérer la sélection média.',
      saveModel: 'Enregistrer le modèle',
      cantEdit: 'Ce modèle provient de votre tête de réseau, vous ne pouvez pas l\'éditer',
      cantDelete: 'Ce modèle provient de votre tête de réseau, vous ne pouvez pas le supprimer',
      backToPosts: 'Retour à mes posts',
      createModel: 'Créer un modèle',
      deleteModelTitle: 'Suppression de modèle',
      deleteModelConfirm: 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
      cancel: 'Annuler',
      delete: 'Supprimer',
      myModels: 'Mes modèles',
      networkModels: 'Modèles du réseau',
      create: 'Créer un modèle de post éditorial',
      edit: 'Editer un modèle',
      use: 'Utiliser',
      modelSummary: 'Résumé du modèle',
      for: 'Pour',
      actions: 'Actions'
    },
    create: {
      core: {
        missingRequiredFields: 'Vous n\'avez pas renseigné les champs requis.',
        putOnDraft: 'Mettre en brouillon',
        missingNetworkSelection: 'Vous n\'avez pas renseigné tous les champs obligatoires ou vous n\'avez sélectionné aucun réseau social pour diffusion.',
        publish: 'Publier',
        cancel: 'Annuler',
        returnToList: 'Retour à la liste',
        modalDeletePlanifBrouillons: 'Vous vous apprêtez à passer ce post en brouillon. Quand vous souhaiterez publier ce post sur les réseaux sociaux de votre choix, vous devrez renseigner une nouvelle date de planification'
      },
      newPost: {
        introText: 'Vous vous apprêtez à créer un nouveau contenu à publier sur vos réseaux sociaux. Pour cela choisir dans un premier temps le type de post parmi ceux qui vous sont proposés et suivez les instructions.',
        createPostLabel: 'Vous souhaitez créer un post',
        selectPostType: 'Choisir le type de post',
        fromAd: 'A partir d\'une annonce',
        fromSoldProperty: 'A partir d\'un bien vendu',
        editorial: 'Editorial',
        fromPostTemplate: 'A partir d\'un modèle de post éditorial',
        selectRelatedAd: 'Sélectionner l\'annonce concernée',
        title: 'Titre',
        reference: 'Référence',
        price: 'Prix',
        alreadyPosted: 'Cette annonce est déjà postée sur un réseau social',
        cancel: 'Annuler',
        editPost: 'Editer le post',
        validateAndContinue: 'Valider et poursuivre'
      },
      deletePlanifBrouillons: {
        title: 'Passer le post en brouillon ?',
        message: 'Vous vous apprêtez à passer ce post en brouillon. Quand vous souhaiterez publier ce post sur les réseaux sociaux de votre choix, vous devrez renseigner une nouvelle date de planification.',
        confirm: 'Je confirme le passage en brouillon',
        cancel: 'Annuler'
      },
      confirmDraft: {
        title: 'Confirmation d\'enregistrement en brouillon',
        message: 'Êtes-vous sûr de vouloir enregistrer ce post en brouillon ?',
        confirm: 'Oui, enregistrer en brouillon',
        cancel: 'Annuler'
      },
      planification: {
        title: 'Planifier vos posts',
        instruction: 'Choisissez quand publier votre contenu sur chacun des réseaux sociaux sélectionnés.',
        selectDateTime: 'Selectionnez date et horaire',
        publishNow: 'Ou publier maintenant',
        alreadyPublishedFacebook: 'Votre post a déjà été diffusé sur Facebook',
        alreadyPublishedInstagram: 'Votre post a déjà été diffusé sur Instagram',
        alreadyPublishedGoogle: 'Votre post a déjà été diffusé sur Google',
        alreadyPublishedLinkedin: 'Votre post a déjà été diffusé sur LinkedIn',
        apply: 'Appliquer mes choix de publication'
      },
      validator: {
        fieldsRequired: 'Vous n\'avez pas renseigné les champs requis.',
        fieldsRequiredComplete: 'Vous devez compléter tous les champs obligatoires : Libellé, contenu, média et choix d\'au moins un réseau social.'
      },
      modalAI: {
        objectTitle: 'Précisez l\'objet du post en quelques mots : "Portes ouvertes", "Recrutement", ...',
        objectSubtitle: 'Plus vous serez précis en amenant des éléments de contexte, plus votre message sera rédigé avec un grand niveau de qualité et de personnalisation.\n' +
          '        <br>NB : Une seule génération grâce à notre IA est possible par média et par post.',
        cancel: 'Annuler',
        generatePost: 'Générer mon post'
      },
      modalIaPost: {
        title: 'Mon assistant IA',
        subtitleChoice: 'Laissez l\'intelligence artificielle vous aider à créer du contenu engageant',
        subtitleSuggestions: 'Sélectionnez un thème parmi nos suggestions pour générer du contenu',
        subtitleIdea: 'Décrivez votre idée et l\'IA générera le contenu pour vous',
        back: 'Retour',
        stepInstruction: 'Choisissez comment vous souhaitez créer votre contenu :',
        cardIdeaTitle: 'J\'ai une idée',
        cardIdeaDescription: 'Rédigez votre propre instruction et laissez l\'IA générer le contenu',
        cardSuggestionsTitle: 'Propose-moi des idées',
        cardSuggestionsDescription: 'Explorez nos thèmes prédéfinis et personnalisez-les selon vos besoins',
        ideaTitle: 'Décrivez votre idée',
        ideaPlaceholder: {
          immoAncien: 'Ex. : Rédige un post sur les quartiers qui montent dans mon secteur',
          cmi: 'Ex. : Rédige un post sur les étapes clés avant de construire sa maison',
          promoteur: 'Ex. : Rédige un post sur les avantages fiscaux d\'investir dans le neuf',
          vo: 'Ex. : Rédige un post sur les avantages d\'acheter un véhicule reconditionné'
        },
        ideaHelp: 'Plus votre description est précise, meilleur sera le résultat',
        themeTitle: 'Sélectionnez un thème',
        themesFetchFailed: 'La récupération des thèmes a échoué. Réessayer plus tard.',
        optionalTitle: 'Précisions supplémentaires (optionnel)',
        optionalPlaceholder: 'Ajoutez des émojis, limitez à 280 caractères, précisez une ville, un ton, etc.',
        optionalHelp: 'Personnalisez le contenu généré selon vos préférences',
        cancel: 'Annuler',
        generateContent: 'Générer le contenu',
        viewProposal: 'Voir la proposition'
      },
      confirmStop: {
        title: 'Annuler la personnalisation du post',
        text: 'Si vous confirmez, la personnalisation de votre post pour ce réseau social sera perdue. Êtes-vous sûr de vouloir continuer ?'
      },
      publishNow: {
        title: 'Publier maintenant',
        text: 'Êtes-vous certain de vouloir publier maintenant votre post sur les réseaux sociaux sélectionnés ?',
        confirm: 'Oui, je veux publier maintenant',
        cancel: 'Revenir à l\'étape précédente'
      },
      confirmStopCustom: {
        title: 'Annuler la personnalisation du post',
        text: 'Si vous confirmez, la personnalisation de votre post pour ce réseau social sera perdue. Êtes-vous sûr de vouloir continuer ?'
      },
      initial: {
        title: 'Publication initiale',
        subtitle: 'Ce contenu initial sera repris pour tous les réseaux sociaux sélectionnés dans la partie droite de cet écran.Vous aurez la possibilité de les modifier et de les personnaliser par canal de diffusion.',
        contentPostTitle: 'Contenu du post',
        selectedTheme: 'Thème sélectionné :',
        libelle: 'Libellé du post *',
        tooltipLibelle: 'Ce libellé ne sera pas diffusé sur les réseaux sociaux et sera uniquement visible de vous.',
        textContent: 'Contenu texte du post *',
        textContentInfo: 'Vous pouvez rédiger librement votre post depuis le champ mis à votre disposition ou profiter de notre\n' +
          '                      outil de génération de posts automatique\n' +
          '                      grâce à notre solution d\'<b>intelligence artificielle</b>. Pour cela, rien de plus simple : cliquez sur\n' +
          '                      le bouton ci-dessous et suivez les instructions.',
        linkToYourVideo: 'Lien vers votre vidéo',
        contentMedia: 'Sélectionnez un type de média à publier. Vous ne pouvez pas combiner image et vidéo dans la même publication.'
      },
      infoMediaType: 'Information importante sur vos médias',
      infoMediaTypeText: 'Nous avons détecté que vous avez intégré une vidéo et une ou plusieurs images. Seule la vidéo sera prise en compte lors de la diffusion de votre publication. Si vous souhaitez publier vos photos sur ce post, vous pouvez supprimer la vidéo.',
      infoMediaTypeButton1: 'Je modifie mon média',
      infoMediaTypeButton2: 'Je valide quand même ce choix',
      mediaType: 'Type de média',
      images: 'Images',
      video: 'Vidéo',
      alreadyPublished: 'Ce post a déjà été publié : <br> suppression ou modification impossible.',
      customizePost: 'Personnaliser le post',
      selectTypePost: 'Sélectionner un type de post *',
      chooseTypeOfPost: 'Choisir le type de post',
      actionButton: 'Bouton d\'action',
      typeOfActionButton: 'Choisir le type de bouton d\'action',
      urlActionButton: 'Lien associé à votre post',
      learnMore: 'En savoir plus',
      tooltipGoogleUTM: 'Si vous possédez un Google Analytics , vous pouvez renseigner ici l\'indice de campagne UTM.',
      postWithPictures: 'Publication avec photo(s)',
      typeNews: 'Actualité',
      redactWithAi: 'Rédiger votre post grâce à l\'IA',
      promoCode: 'Code promotionnel',
      promoCodeDetail: 'Si vous souhaitez proposer un code promotionnel utilisable en ligne ou sur le point de vente.',
      offerLink: 'Lien de l\'offre',
      offerLinkDetail: 'Précisez l\'URL de la page permettant de profiter de l\'offre en ligne.',
      medias: 'Médias',
      IAButtonDisabled: 'Veuillez renseigner le libellé avant de faire appel à l\'IA',
      aiGenerationLoading: 'Génération du contenu par intelligence artificielle…',
      useAnotherPicture: 'Je souhaite utiliser les photos de ma publication initiale (à gauche) pour ce réseau social.',
      dontuseAnotherPicture: 'Je souhaite utiliser d\'autres photos que celles de la publication intiale pour ce réseau social.',
      saveDraft: 'Enregistrer en brouillon',
      publish: 'Publier'
    },
    confirmDelete: {
      title: 'Suppression de post',
      confirmDeleteSingle: 'Vous êtes sur le point de supprimer le post suivant :',
      confirmDeleteMultiple: 'Vous êtes sur le point de supprimer les posts suivants :',
      confirmDeleteMultipleBV: 'Vous êtes sur le point de supprimer les posts de biens vendus suivants :',
      onlyNotDiffused: 'Attention : seuls les posts non diffusés peuvent être supprimés.',
      notPossible: 'La suppression n\'est pas possible.',
      warningTitle: 'Attention',
      warningPublished: 'Certains posts ont déjà été publiés sur les réseaux sociaux suivants :',
      confirmChoice: 'Êtes-vous sûr de vouloir continuer ?',
      cancel: 'Annuler',
      confirmDelete: 'Confirmer la suppression'
    },
    diffusionDisabled: '<p>La gestion de vos posts éditoriaux sur {{ networkName }} n\'est pas activée.<br><br>' +
                       'Plusieurs raisons peuvent l\'expliquer :</p>' +
                       '<ul style="font-weight: 100">' +
                       '<li>Vous n\'avez pas encore finalisé la passation des droits nécessaires à notre équipe de relation client.</li>' +
                       '<li>Vous n\'êtes pas présent sur ce réseau social.</li>' +
                       '<li>Vous n\'avez pas activé ce réseau social dans votre package Ubiflow.</li></ul>' +
                       '<p>Saviez-vous qu\'en gérant l\'intégralité de votre stratégie social média depuis votre Espace Client Ubiflow vous optimisez votre visibilité sur les réseaux sociaux et vous gagnez jusqu\'à 4 fois plus de temps ?</p>',
    iWantToEnableThisNetwork: 'Je souhaite activer ce réseau social'
  },
  socialReviews: {
    backToReviews: 'Retour aux avis clients',
    enterMail: 'Entrez le mail du destinataire',
    objectMail: 'Sollicitation d\'avis ',
    objectMailFacebook: 'Sollicitation d\'avis Facebook',
    objectMailGoogle: 'Sollicitation d\'avis Google',
    sir: 'Madame, Monsieur',
    contentMailImmo: 'Nous vous remercions  pour votre confiance dans votre récente acquisition avec notre agence.\n' +
      'Dans le cadre de notre engagement continu à améliorer nos services, nous souhaiterions recueillir votre retour d\'expérience.\n' +
      'Votre avis est précieux pour nous aider dans l\'amélioration de nos services.',
    contentMailVO: 'Nous vous remercions  pour votre confiance dans votre récente acquisition au sein de notre concession.\n' +
      'Dans le cadre de notre engagement continu à améliorer nos services, nous souhaiterions recueillir votre retour d\'expérience.\n' +
      'Votre avis est précieux pour nous aider dans l\'amélioration de nos services.',
    deviseMail: 'Il vous suffit de cliquer sur le lien ci-dessous pour laisser un avis.',
    sincerely: 'Cordialement, ',
    sendMailSuccess: 'Votre demande de suggestion d\'avis a été bien envoyé avec succès.',
    tooltipMessage: 'Le texte ci-dessous est une suggestion Ubiflow. Vous pouvez modifier son contenu en cliquant sur la zone que vous souhaitez changer.',
    sendMailError: 'Une erreur est survenue lors de votre demande de suggestion d\'avis.',
    sendMailErrorLinks: 'Erreur: Vous tentez d\'envoyer un mail sans lien.',
    sendNetworkIsNotValid: 'Merci de sélectionner au moins 1 réseau social.',
    suggestedReviews: 'Sollicitation d\'avis',
    title: 'Avis clients',
    description: 'Depuis cet onglet, vous trouverez tous les avis clients de vos pages Google et Facebook.',
    search: {
      openSearch: 'Recherche libre',
      media: 'Media',
      rate: 'Note',
      creationDate: 'Date de création',
      detectionDate: 'Date de détection',
      review: 'Avis',
      allReview: 'Tous',
      new: 'Nouveau',
      toAnswer: 'A répondre',
      answered: 'Répondu',
      deleted: 'Supprimé'
    },
    modal: {
      respondToReview: 'Répondre à l\'avis',
      respondToIA: 'Répondre avec l\'IA',
      messageModal: 'Vous avez répondu à cet avis'
    },
    table: {
      messageAnswer: 'Vous n\'avez pas répondu à cet avis'
    },
    stats: {
      reviewCount: 'Nombre d\'avis',
      unansweredReviewsCount: 'Avis en attente de réponse',
      averageRate: 'Note moyenne'
    },
    autoAnswers: {
      title: 'Réponses automatiques aux avis sans texte',
      subtitle: 'Vous avez la possibilité de rédiger des réponses qui seront automatiquement envoyées aux avis qui ne contiennent pas de texte.',
      rate: 'Note',
      noAutoAnswer: 'Vous n\'avez pas de réponse automatique pour cette note',
      edit: 'Modifier'
    },
    export: {
      fileNameExportReviews: 'liste_avis_clients',
      noticeContent: 'Contenu de l\'avis',
      dateOfPublication: 'Date de publication',
      dealerName: 'Nom du déposant',
      pointOfSaleName: 'Point de vente',
      numberOfStars: 'Nombre d\'étoiles'
    },
    titleSuggestedReviews: 'Email de sollicitation d\'avis clients',
    text1SuggestedReviews: 'Depuis cette page, vous pouvez envoyer un email pour solliciter des avis auprès de vos clients en rédigeant votre propre texte ou en utilisant l\'exemple déjà créé.',
    text2SuggestedReviews: 'Grâce aux liens de redirection vers vos pages Google et Facebook, vos clients n\'ont qu\'un clic à faire pour déposer un avis.',
    emailIsEmpty: 'L\'email du destinataire est vide. Veuillez remplir ce champ.',
    sendSelected: 'Envoyer la sélection'
  },
  contactManager: {
    contactsGenerated: 'Contacts générés',
    allContacts: 'Tous les contacts',
    summaryOfContacts: 'Statistiques',
    contactsByPost: 'Contacts par annonces',
    contactsByPortal: 'Contacts par portails',
    contactsByPrograms: 'Contacts par programmes',
    defaultContactsPeriodInfo: 'Les contacts indiqués ci-dessous correspondent par défaut à ceux des 7 derniers jours. Vous pouvez modifier la périodicité grâce aux filtres mis à votre disposition ci-dessus.',
    sevenDays: 'Contacts sur les 7 derniers jours'
  },
  broadcasts: {
    broadcastLists: 'Liste des diffusions',
    broadcastSocialNetworks: 'Diffusion réseaux sociaux',
    optimizeBroadcast: 'Optimiser ma diffusion'
  },
  socialNetworks: {
    dialogPagesSelection: 'Merci de sélectionner la page Facebook sur laquelle vous souhaitez diffuser vos publications',
    messageFacebookAutologin: 'Identifiez-vous à nouveau avec votre compte pro afin de renouveler les droits de publication de l\'application',
    titleFacebookPages: 'Pages autorisées pour la publication des posts',
    facebookDeconnexion: 'Se déconnecter de Facebook',
    googleDeconnexion: 'Se déconnecter de Google',
    dialogLocationsSelection: 'Merci de sélectionner votre établissement Google sur lequel vous souhaitez diffuser vos publications',
    dialogOrganizationsSelection: 'Merci de sélectionner votre organisation Linkedin sur lequel vous souhaitez diffuser vos publications',
    badgeConnected: 'Connecté',
    sectionActionsRequired: 'Action requise',
    sectionActionsRequired_plural: 'Actions requises',
    sectionActiveConnections: 'Connexion active',
    sectionActiveConnections_plural: 'Connexions actives',
    reconnect: 'Se reconnecter',
    contactUs: 'Nous contacter',
    emailSend: 'Votre demande a bien été envoyée. Notre équipe va revenir vers vous dans les meilleurs délais.',
    disconnect: 'Se déconnecter',
    lockedMessage: 'Cette diffusion n\'est pas encore activée sur votre compte. Contactez-nous pour souscrire.',
    disconnectConfirm: 'Êtes-vous sûr de vouloir vous déconnecter de {{network}} ?',
    disconnectConfirmTitle: 'Déconnexion',
    disconnectConfirmButton: 'Confirmer',
    disconnectCancelButton: 'Annuler',
    disconnectError: 'Une erreur est survenue lors de la déconnexion.',
    gmbManagedByNetwork: 'La connexion à Google My Business est gérée par le réseau',
    newPost: {
      introText: 'Vous vous apprêtez à créer un nouveau contenu à publier sur vos réseaux sociaux. Pour cela choisir dans un premier temps le type de post parmi ceux qui vous sont proposés et suivez les instructions.',
      createPostLabel: 'Vous souhaitez créer un post',
      selectPostType: 'Choisir le type de post',
      fromAd: 'A partir d\'une annonce',
      fromSoldProperty: 'A partir d\'un bien vendu',
      editorial: 'Editorial',
      fromPostTemplate: 'A partir d\'un modèle de post éditorial',
      selectRelatedAd: 'Sélectionner l\'annonce concernée',
      title: 'Titre',
      reference: 'Référence',
      price: 'Prix',
      alreadyPosted: 'Ce post a déjà été créé et diffusé sur un ou plusieurs réseaux sociaux à partir de cette annonce.',
      noEditable: 'Vous ne pouvez plus l\'éditer.',
      cancel: 'Annuler',
      editPost: 'Editer le post',
      validateAndContinue: 'Valider et poursuivre'
    }
  },
  tutoralsVideos: {
    menu: {
      titleMenu: 'Sommaire',
      linkDashboard: 'Tableau de bord',
      linkAnnouncementsPage: '  Annonces',
      linkProgramsPage: '  Programmes',
      linkBroadcast: 'Diffusion',
      linkContactManager: 'Contact Manager',
      linkSocialManagement: 'Social Manager'
    },
    subMenu: {
      linkReviews: 'Avis clients'
    },
    title: 'Vidéos tutoriels',
    infoButtonGoToBack: 'Retour à l\'espace client',
    textButtonGuide: 'Export du guide d\'utilisation',
    label: 'Nouvelle vidéo',
    videos: {
      title1: 'Découvrez votre tableau de bord',
      description1: 'Cette première video vous permettra d\'apprehender votre Espace utilisateur et de découvrir les différents éléments intégrés à votre tableau de bord. Découvrons ensemble les premiers onglets pour une première appréhension de votre environnement.',
      title2: 'Maitrisez l\'onglet annonce',
      description2: 'Depuis notre outil de saisie, vous pouvez créer une annonce à tout moment grâce au bouton constamment accessible "Créer une annonce" de votre espace client. Il vous sera notamment possible d\'ajouter une description personnalisée et du contenu média.',
      title3: 'L\'onglet diffusion',
      description3: 'Depuis l\'onglet "Diffusion", vous pouvez consulter et modifier votre liste de diffusion et recevoir également un rapport de diffusion du portail et gérer la diffusion de vos annonces sur un portail.',
      title4: 'Découverte de l\'onglet Contact Manager',
      description4: 'Découvrez l\'onglet Contact Manager qui vous permet la gestion et la centralisation de vos contacts et le suivi des interactions.',
      title5: 'Création d\'une annonce',
      description5: 'Découvrez comment créer et publier une annonce avec succès depuis votre espace utilisateur Ubiflow et simplifier l\'envoi de vos posts d\'annonces.',
      title6: 'Réponse à un avis client',
      description6: 'Découvrez comment répondre aux avis clients directement depuis l\'espace client Ubiflow ! Dans cette vidéo, nous vous montrons étape par étape comment utiliser cette fonctionnalité pratique pour interagir avec vos clients et gérer efficacement votre réputation en ligne.'
    }
  },
  statisticsMeta: {
    networksStatistics: 'Les statistiques de vos réseaux sociaux',
    overview: 'Vue d\'ensemble',
    publicationReport: 'Rapport par post',
    discover: 'Découvrir',
    publishedOn: 'Publié le',
    interactions: 'Interactions',
    titleFacebook: 'Statistiques de votre page Facebook',
    titleInsta: 'Statistiques de votre page Instagram',
    likedPage: 'Mentions j\'aime de la page ',
    viewsNumber: 'Nombre de vues',
    followersNumber: 'Nombre de followers ',
    likeNumber: 'Nombre de j\'aime',
    numberPublication: 'Nombre de publications',
    allNumberViews: 'Nombre total de vues des médias ',
    publication: 'Publications ',
    totalInteractions: 'Le nombre total d\'interactions avec vos publications',
    reach: 'Nombre total de vues uniques des médias',
    shares: 'Nombre de partages',
    reference: 'Référence',
    description: 'Texte du post',
    savesNumber: 'Nombre d\'enregistrements',
    saves: 'Nombre d\'enregistrements de votre contenu',
    comments: 'Nombre de commentaires',
    likes: 'Mentions J\'aime sur votre contenu',
    accountsEngaged: 'Nombre de comptes qui ont interagi avec votre contenu',
    pageDailyFollows: 'Le nombre de personnes qui suivent votre page Facebook ',
    pagePostEngagements: 'Le nombre d\'interactions avec vos publications',
    pageTotalActions: 'Le nombre de clics sur les coordonnées de votre Page',
    postsInsta: 'Publications Intagram',
    postsFacebook: 'Publications Facebook',
    growingYourInstagramCommunity: 'Évolution de votre communauté Instagram',
    growingYourFacebookCommunity: 'Évolution de votre communauté Facebook',
    boxInfosContentFacebook: 'Vous devez disposer d\'au moins 100 like de votre page Facebook pour avoir des statistiques disponibles.',
    boxInfosContentInstagram: 'Vous devez avoir au moins 100 followers de votre page Instagram pour avoir des statistiques disponibles.',
    toolTipsStatsContent: 'Ces statistiques concernent les performances globales de votre page. Les filtres n\'affectent pas ces données.',
    toolTipsStatsGraphContent: 'Utilisez les filtres pour mettre en avant les chiffres que vous souhaitez consulter.',
    seePostDetails: 'Voir le detail du post',
    loadingInProgress: 'Chargement en cours...',
    nbPeopleWhoSeenPublications: 'Nombre de personnes qui ont vu vos publications',
    infoNumberStats: 'Les chiffres présents dans la section "Interactions" sont en lien avec la période indiquée sur le graphique d\'évolution de la communauté.'
  },
  statisticsLinkedin: {
    titleLinkedin: 'Statistiques de votre page Linkedin',
    discover: 'Découvrir',
    postsLinkedin: 'Publications Linkedin',
    growingYourLinkedinCommunity: 'Évolution de votre communauté Linkedin',
    numberImpressionTotal: 'Nombre d\'impressions total',
    followersNumber: 'Nombre de followers sur la page',
    followersNumberByMonth: 'Nombre de followers en plus par mois',
    numberOfReaction: 'Nombre de réactions',
    numberOfComments: 'Nombre de commentaires',
    numberOfShare: 'Nombre de partages',
    numberCliksOntheLink: 'Nombre de clics sur le lien',
    content: 'Pour visualiser les statistiques LinkedIn depuis votre Espace Client, vous devez être Super Administrateur ou Administrateur de la page entreprise.'
  },
  statisticsDBKS: {
    numberEditorial: 'Nombre de post(s) éditoriaux',
    numberAdsPost: 'Nombre de post(s) annonces',
    numberDraftPost: 'Nombre de post(s) en brouillon',
    statusOfBroadcasts: 'Statut du partage de vos informations sur les différents médias',
    contentOfBroadcasts: 'La solution de présence locale vous permet de diffuser vos informations sur les différents médias associés (Google maps, Apple plans, Waze...).',
    broadcast: 'Diffusions',
    inProgress: 'En cours de diffusion',
    broadCastError: 'Erreur de diffusion',
    total: 'Total',
    other: 'autres'
  },
  statistics: {
    linkToStatistics: 'Accéder à vos statistiques',
    linkToReportByPosts: 'Accéder à vos rapports par post',
    GrowingYourCommunityOnSocialNetworks: 'Évolution de votre communauté sur les différents réseaux sociaux',
    titleAd: 'Titre du post',
    publishedAt: 'Publié le ',
    top: 'TOP'
  },
  ecModal: {
    close: 'Fermer',
    dontShowAgain: 'Ne plus afficher'
  },
  autoOpenDialog: {
    title: 'Nouveauté Social Manager',
    content: 'Vous pouvez désormais consulter les statistiques de vos comptes Facebook et Instagram directement depuis la rubrique "Statistiques" de votre Espace Client. ',
    content1: 'Pour cela, cliquez sur le bouton ci-dessous, puis sur le bouton "Facebook login" se trouvant sur la page d\'atterrissage.',
    content2: 'Afin de permettre la remontée de vos statistiques, le réseau social impose <strong>100 like de votre page Facebook</strong> et <strong>100 followers de votre compte Instagram</strong>. Si ce n\'est pas le cas, n\'hésitez pas à faire vivre votre communauté en publiant plus de posts grâce à notre solution Social Manager !',
    titleCancelledButton: 'Annuler',
    titleConfirmButton: 'Accéder',
    disabledMessage: 'Ne plus recevoir ce message'
  },
  autoOpenDialogLinkedin: {
    title: 'Nouveauté Social Manager',
    content: 'Vous pouvez désormais consulter les statistiques de votre compte Linkedin directement depuis la rubrique "Statistiques" de votre Espace Client. ',
    content1: 'Pour cela, cliquez sur le bouton ci-dessous, puis sur le bouton "Linkedin login" se trouvant sur la page d\'atterrissage.',
    content2: 'Attention ! Pour visualiser les statistiques LinkedIn depuis votre Espace Client, vous devez être Super Administrateur ou Administrateur de la page entreprise.',
    titleCancelledButton: 'Annuler',
    titleConfirmButton: 'Accéder',
    disabledMessage: 'Ne plus recevoir ce message'
  },
  autoOpenDialogGoogle: {
    title: 'Nouveauté Social Manager',
    content: 'Vous pouvez désormais consulter les statistiques de votre compte Google directement depuis la rubrique "Statistiques" de votre Espace Client. ',
    content1: 'Pour cela, cliquez sur le bouton ci-dessous, puis sur le bouton "Google login" se trouvant sur la page d\'atterrissage.',
    content2: 'Attention ! Pour visualiser les statistiques Google business profile depuis votre Espace Client, vous devez être Super Administrateur ou Administrateur de la page entreprise.',
    titleCancelledButton: 'Annuler',
    titleConfirmButton: 'Accéder',
    disabledMessage: 'Ne plus recevoir ce message'
  },
  tokensExpiresDialog: {
    title: 'Connexion à vos réseaux sociaux',
    content: 'Bonjour, <br />Nous avons constaté que votre connexion a expiré pour le(s) réseau(x) social(aux) suivant :',
    content1: 'Pour rétablir la diffusion de vos annonces, cliquez sur le bouton « Accéder » et reconnectez-vous <br />au(x) réseau(x) social(aux) mentionné(s) ci-dessus.',
    titleCancelledButton: 'Annuler',
    titleConfirmButton: 'Accéder'
  },
  KPI: {
    messageErrorLoading: 'Une erreur est survenue lors du chargement'
  },
  etablishmentSheet: {
    beginning: 'Début',
    ending: 'Fin',
    messageLoadData: 'Une erreur est survenue lors du chargement des données.',
    messageUploadPhotoError: 'Une erreur est survenue lors du chargement des photos.',
    messageUploadPhotoSuccess: 'Vos photos ont bien été enregistrées et elles vont être mise à jour.',
    messageDeletedPhotoError: 'Une erreur est survenue lors de la suppression.',
    messageDeletedPhotoSuccess: 'Votre photo a bien été supprimée.',
    errorPhoto2004: 'Les données rentrées sont invalides.',
    errorPhoto2501: 'Le POI a trop de photos.',
    errorPhoto2502: 'Le POI doit avoir au moins une photo.',
    errorPhoto2503: 'Impossible d\'obtenir la photo.',
    errorPhoto2504: 'Méthode photo non gérée',
    errorPhoto2505: 'La photo est trop petite.',
    errorPhoto2506: 'La photo est trop grande.',
    errorPhoto2507: 'La photo a un mauvais ratio.',
    errorPhoto2508: 'Le poids de la photon\'est pas valide.',
    errorPhoto2509: 'La photo est dupliquée.',
    errorPhoto2510: 'La photo est immuable.',
    errorPhoto2511: 'Supprimé la photo avant d\'en télécharger une nouvelle.',
    title: 'Données sur votre fiche d\'établissement',
    subtitleValidationData: 'Données de validation',
    subtitleDataGeneral: 'Données générales',
    subtitleAdress: 'Adresse',
    subtitlePhotos: 'Photos',
    subtitleVideos: 'Vidéos',
    subtitleSchedules: 'Horaires',
    subtitleExceptionalSchedules: 'Horaires Exceptionnels',
    subtitleWebsites: 'Sites web',
    idExternal: 'Id Externe',
    companyName: 'Raison sociale',
    tradeName: 'Nom du commerce',
    longTradeName: 'Nom long du commerce',
    contactName: 'Nom du contact',
    firstNameOfContact: 'Prénom du contact',
    phone: 'Téléphone',
    phone2: 'Téléphone 2',
    phone3: 'Téléphone 3',
    mobile: 'Mobile',
    mail: 'Email du commerce',
    mailAdmin: 'Email administratif',
    statusCompany: 'Statut du commerce',
    placeholderStatusCompany: 'Merci de selectionner le status',
    underConstruction: 'En construction (jamais ouvert)',
    temporarilyClosed: 'Fermé temporairement',
    siret: 'Siret',
    openingDate: 'Date d\'ouverture',
    mediaStoreGoogle: 'Store codes Medias (Google)',
    validationMobile: 'Validation : Numéro de mobile',
    validationMail: 'Validation : Adresse mail',
    businessAddress: 'Adresse du commerce',
    businessAddressComplement: 'Complément d\'adresse du commerce',
    postalCodeCompany: 'Code postal du commerce',
    cityCompany: 'Ville du commerce',
    country: 'Pays du commerce',
    latitude: 'Latitude',
    longitude: 'Longitude',
    geoTitleButton: 'Géolocaliser l\'adresse sur la carte',
    addCatchmentArea: 'Ajouter une zone de chalandise',
    infoCatchmentAreaContent1: 'Nous recommandons d\'utiliser des zone de chalandise par PlaceId afin d\'améliorer leur précision.',
    infoCatchmentAreaContent2: 'Pour cela, vous pouvez utiliser le ',
    infoCatchmentAreaContent2Suite: 'mis à disposition par Google.',
    infoCatchmentAreaContent3: 'Le résultat s\'affichera sous forme d\'infobulle. La première ligne en gras correspond au nom et la seconde au PlaceId',
    days: 'Jours',
    date: 'Dates',
    status: 'Statut',
    fullHours: '24/24',
    duplicate: 'Dupliquer',
    delete: 'Supprimer',
    addSchedule: 'Ajouter une période',
    actions: 'Actions',
    open: 'Ouvert',
    close: 'Fermé',
    save: 'Enregistrer le formulaire',
    savePictures: 'Enregistrer les photos',
    cancel: 'Annuler',
    create: 'Créer',
    logo: 'Logo',
    profile: 'Profil',
    cover: 'Couverture',
    gallery: 'Galerie',
    minSize: '450x450px minimum',
    maxSize: '5200x5200px maximum',
    weightBetween: 'Entre 10Ko et 4Mo',
    maxPhotosGallery: 'Maximum 20 photos',
    chooseFile: 'Choisir un fichier',
    chooseAddDay: 'Ajouter une journée',
    chooseSeveralDays: 'Ajouter plusieurs jours',
    tooltipContentIdExterne: 'Saisissez l\'identifiant en chiffres et/ou en lettres qui sera unique à cet établissement',
    tooltipContentCompanyName: 'Raison sociale du point d\'interêt',
    tooltipContentNomCommerce: 'Nom du point d\'interêt',
    tooltipContentLongName: 'Nom long, utilisé en priorité sur certains médias qui le permettent (Google...)',
    tooltipContentContactName: 'Nom du contact du point d\'interêt',
    tooltipContentContactFirstname: 'Prénom du contact du point d\'interêt',
    tooltipContentPhone: 'Téléphone principal du point d\'interêt',
    tooltipContentPhone2: 'Téléphone n°2 du point d\'interêt',
    tooltipContentPhone3: 'Téléphone n°3 du point d\'interêt',
    tooltipContentMobile: 'Téléphone mobile du point d\'interêt',
    tooltipContentMail: 'Adresse email public envoyée aux portails pour publication en tant que "contact"',
    tooltipContentMailAdmin: 'Adresse email privée, utilisée pour la gestion de la prestation et l\'administration des fiches notamment dans Google My Business',
    tooltipContentStatus: 'Statut du point d\'interêt',
    tooltipContentSIRET: 'Numéro SIRET du point d\'interêt',
    tooltipContentOpeningDate: 'Il s\'agit de la date de la première ouverture de votre point de vente, elle doit être dans le passé ou à maxima 1 an dans le future',
    tooltipContentStoreCodeMedias: 'Store codes sur les médias',
    tooltipContentValidationDataMobile: 'Numéro de téléphone mobile utilisé pour valider l\'enregistrement sur le GBP.',
    tooltipContentValidationDataMail: 'Adresse email utilisée pour valider l\'enregistrement sur le GBP.',
    tooltipContentAdresseCommerce: 'Adresse du point d\'intérêt (ligne 1)',
    tooltipContentAdresseCommerce2: 'Adresse du point d\'intérêt (ligne 2)',
    tooltipContentLatitude: 'Latitude du point d\'intérêt (position dans la rue ou dans le centre commercial)',
    tooltipContentLongitude: 'Longitude du point d\'intérêt (position dans la rue ou dans le centre commercial)',
    saveConfirmation: 'Voulez-vous vraiment enregistrer le formulaire ?',
    saveConfirmationPictures: 'Voulez-vous vraiment enregistrer les photos ?',
    errorSave: 'Les informations n\'ont pas pu être enregistrées suite à une annulation ou une erreur.',
    errorSavePictures: 'Les photos n\'ont pas pu être enregistrées suite à une annulation ou une erreur.',
    successSave: 'Les modifications ont bien été enregistrées.',
    cancelConfirmation: 'Voulez-vous vraiment annuler votre enregistrement ?',
    addVideo: 'Ajouter une vidéo',
    contentVideo: 'Vous pouvez ajouter plusieurs liens vers des vidéos. Elles seront analysées puis diffusées sur les médias concernés à condition qu\'elles respectent les contraintes suivantes :',
    conditionVideo: 'L\'url doit être un accès direct au fichier.',
    exampleVideo: 'Exemple: https://exampleVideo/2ssezdsez2dd15e.mp4',
    addUrlVideo: 'Ajouter l\'url de la video',
    minWeightVideo: 'Poids : 75 Mio maximum',
    timeMaxVideo: 'Durée : 30 secondes maximum',
    resolutionVideo: 'Résolution : 720p minimum',
    warningDiffusion: 'Attention ! Toute diffusion est définitive et votre lien ne peut pas être supprimé.'
  },
  statisticsGoogle: {
    overview: 'Vue d\'ensemble',
    titleGoogle: 'Statistiques générales de Google',
    sheetEtablishmentEngagement: 'Engagement sur la fiche d\'établissement',
    actions: 'Actions réalisées à partir de la fiche d\'établissement',
    titleGoogleGraph: 'Évolution du nombre de recherches Google',
    messages: 'Messages',
    searchByDesktop: 'Recherche Google par ordinateur',
    searchGoogleMapsByDesktop: 'Recherche Google Maps par ordinateur',
    searchByMobile: 'Recherche Google par mobile',
    searchGoogleMapsByMobile: 'Recherche Google Maps par mobile',
    numberSearchByDay: 'Nombre de recherche par jour',
    numberConversationByDay: 'Nombre de conversations par message reçues sur la fiche d\'établissement.',
    numberCallItinerary: 'Nombre de demande d\'itinéraire.',
    numberClickedButtonCall: 'Nombre de clics sur le bouton d\'appel.',
    numberClickedWebSite: 'Nombre de clics sur le site Web.',
    infoNumberStats: 'Les chiffres présents dans la section "Sur la fiche d\'établissement" sont en lien avec la période indiquée sur le graphique d\'évolution de la communauté.'
  },
  SOH: {
    chooseDate: 'Choisissez une date',
    textLinked: 'État de santé de la batterie fourni par un organisme certifié tel que',
    warnings: {
      lowScore: 'Attention : Un score SOH inférieur à 70% indique une batterie en mauvais état.'
    },
    validation: {
      soh: {
        scoreInvalid: 'Le score SOH doit être un nombre valide.',
        scoreRange: 'Le score SOH doit être compris entre 0 et 100%.',
        dateRequired: 'La date du test SOH est obligatoire.',
        dateFormat: 'Le format de date doit être JJ/MM/AAAA.',
        dateFuture: 'La date du test ne peut pas être dans le futur.',
        kilometrageInvalid: 'Le kilométrage doit être un nombre valide.',
        kilometrageNegative: 'Le kilométrage ne peut pas être négatif.',
        capaciteInvalid: 'La capacité doit être un nombre valide.',
        capacitePositive: 'La capacité doit être supérieure à 0.',
        autonomieInvalid: 'L\'autonomie doit être un nombre valide.',
        autonomiePositive: 'L\'autonomie doit être supérieure à 0.',
        expirationPast: 'La date d\'expiration doit être dans le futur.',
        urlInvalid: 'L\'URL n\'est pas valide'
      }
    }
  },
  qualiforma: {
    donneesQualiforma: 'Données Qualiforma',
    nbFormEnvoyes: 'Nombre formulaire(s) envoyé(s)',
    nbFormRetournes: 'Nombre formulaire(s) retourné(s)',
    dont: 'dont',
    location: 'location(s)',
    transaction: 'transaction(s)',
    noData: 'Aucune donnée'
  },
  socialMedia: {
    title: 'Éléments préparatoires',
    description: 'Les médias choisis ici seront appliqués à tous les réseaux sélectionnés à droite du formulaire. Vous pourrez ensuite les ajuster et générer un message personnalisé grâce à notre IA pour chaque canal.',
    titleTitle: 'Titre de l\'annonce',
    titleDescription: 'Cette information non éditable ne sera pas diffusée sur les réseaux sociaux.',
    titleMedias: 'Médias',
    titlePhotoGallery: 'Ma Galerie de Photos',
    titleEmptyMessage: 'Aucune photo à afficher',
    titleSelection: 'Sélectionnez votre vidéo',
    titleInputUrl: 'URL de votre vidéo',
    titleHelp: 'Le lien que vous insérez ici doit être celui d\'un fichier hébergé par vos soins. Ne pas renseigner de liens de type Youtube, Viméo et autres qui sont des liens de lecture. Ceux-ci ne sont pas acceptés par les réseaux sociaux.',
    titleFlowVideo: 'Section Flow Vidéo',
    titleFlowVideoDescription: 'Vous pouvez ajouter plusieurs liens vers des vidéos. Elles seront analysées puis diffusées sur les médias concernés à condition qu\'elles respectent les contraintes suivantes :',
    titleFlowVideoCondition: 'L\'url doit être un accès direct au fichier.',
    titleFlowVideoExample: 'Exemple: https://exampleVideo/2ssezdsez2dd15e.mp4',
    buttonContactTeam: 'Contactez notre équipe si vous êtes intéressé',
    buttonSave: 'Enregistrer',
    buttonSaveAndLeave: 'Enregistrer et quitter',
    buttonSaveChanges: 'Enregistrer les modifications',
    noCaption: 'Aucune modification détectée dans les textes.',
    errorCaptionSaving: 'Erreur lors de la sauvegarde des textes : ',
    noNetworkSelected: 'Veuillez d\'abord sélectionner au moins un réseau social en cochant sa case.',
    emptyCaptionMessage1: 'Aucun texte de publication n’a été générée pour : ',
    emptyCaptionMessage2: '.Vous pouvez tout de même programmer votre publication.',
    buttonEdit: 'Modifier la planification',
    buttonPublish: 'Planifier',
    buttonCancel: 'Annuler',
    messageError: 'Aucune publication n\'a pu être programmée',
    messageSuccessPublish: 'Publication(s) programmée(s) avec succès!',
    messageSuccessPublishWithDeletions: 'Publication(s) programmée(s) avec succès ',
    messageSuccessDelete: 'Planification(s) supprimée(s) avec succès!',
    messageInfo: 'Veuillez d\'abord sélectionner au moins un réseau social en cochant sa case.',
    messageErrorPublish: 'Erreur lors de la publication: ',
    messageErrorPublishUnknown: 'Erreur inconnue',
    messageErrorPublishContent: 'Le contenu de votre post doit être complété pour {network}',
    messageErrorPublishContentUnknown: 'Erreur inconnue',
    messageCustomError: 'Erreur lors de la {option} de {network}: {error}',
    statusPublished: 'Publié le',
    statusScheduled: 'Planifié le',
    titleContent: 'Contenu du texte de la publication',
    titleContentDescription: 'Vous pouvez rédiger librement votre post depuis le champ mis à votre disposition ou profitez de notre outil de génération de post automatique grâce à notre solution d\'Intelligence Artificielle. Pour cela, rien de plus simple : cliquez sur le bouton ci-dessous et suivez les instructions.',
    tooltipPromptInstruction: 'Attention, une seule sélection d\'instruction est possible. Une fois générée, vous ne pourrez pas revenir en arrière.',
    titlePublishScheduleModal: 'Sélectionner les réseaux sociaux',
    radioNow: 'Publier maintenant',
    radioScheduled: 'Planifier',
    radioRemove: 'Supprimer la planification',
    summary: 'Résumé de la planification',
    summaryNetwork: 'Réseau',
    summaryAction: 'Action',
    summaryDate: 'Date de publication',
    actionRemoveSchedule: 'Suppression de planification',
    actionRepublication: 'Republication',
    actionModification: 'Modification de planification',
    actionRemove: 'Suppression',
    actionPublication: 'Publication immédiate',
    actionPublicationScheduled: 'Publication planifiée',
    actionDate: 'Date non définie',
    now: 'Maintenant',
    onlyOnePhoto: 'Seule la première photo sera diffusée sur Google.',
    photosLimitInfo: '{displayedCount}/10 photos affichées ({totalPhotos - displayedCount} photos non affichées).',
    photosInfo: '{displayedCount} photo{displayedCount > 1 ? "s" : ""} ser{displayedCount > 1 ? "ont" : "a"} diffusée{displayedCount > 1 ? "s" : ""} sur {networkName}.',
    photosLimitInfoAllRs: 'Seules les 10 premières photos seront diffusées sur les réseaux sociaux et 1 seule pour Google.',
    infoMediaType: 'Information importante sur vos médias',
    infoMediaTypeText: 'Nous avons détecté que vous avez intégré une vidéo et une ou plusieurs images. Seule la vidéo sera prise en compte lors de la diffusion de votre publication. Si vous souhaitez publier vos photos sur ce post, vous pouvez supprimer la vidéo.',
    infoMediaTypeButton1: 'Je modifie mon média',
    infoMediaTypeButton2: 'Je valide quand même ce choix',
    mediaType: {
      image: 'Je choisis de présenter mon bien en photos',
      imageEdito: 'Je choisis d\'illustrer mon post en image',
      url: 'Je choisis de présenter mon bien avec une url vidéo',
      urlEdito: 'Je choisis de présenter mon post avec une url vidéo',
      upload: 'Je choisis de présenter mon bien avec une vidéo téléchargée',
      uploadEdito: 'Je choisis de présenter mon post avec une vidéo téléchargée'
    },
    goBackPicturesOrUpload: 'Si vous souhaitez revenir sur la sélection des photos de l\'annonce ou changer de format vidéo, vous devez vider le champs ci-dessus ou supprimer la vidéo téléchargée.',
    goToAd: 'Retour à l\'annonce',
    saveSucessCaption: ' texte(s) sauvegardé(s) avec succès.',
    loadingInfo: 'Chargement des informations vidéo...',
    uploading: 'Téléchargé',
    videoUploading: 'Vidéo téléchargée',
    deletedVideo: 'Supprimer la vidéo',
    choiceVideo: 'Choisir une vidéo',
    uploadStarting: 'Téléchargement en cours...',
    acceptedFormats: 'Fichiers vidéo (MP4, AVI, MOV, WEBM)',
    uploadError: 'Erreur lors de l\'upload',
    uploadSuccess: 'Vidéo uploadée avec succès!',
    videoDeleted: 'Vidéo supprimée avec succès!',
    videoDeletedError: 'Erreur lors de la suppression de la vidéo',
    uploadErrorData: 'Impossible de supprimer la vidéo - données manquantes',
    confirmDeleted: 'Êtes-vous sûr de vouloir supprimer cette vidéo ?',
    confirmDeletedTitle: 'Confirmation',
    confirmDeletedButton: 'Supprimer',
    confirmDeletedCancelButton: 'Annuler',
    noVideoToDelete: 'Aucune vidéo à supprimer',
    noAllConditionToDelete: 'Conditions non remplies pour la suppression:',
    impossibleLoadCardVideo: 'Impossible de charger la vignette vidéo',
    videoOfPost: 'Vidéo du post',
    tempError: 'Erreur lors du chargement de la vidéo temporaire:',
    newVideo: 'Nouvelle vidéo',
    starting: 'En cours...',
    treatmentVideo: 'Traitement de la vidéo'
  },
  contactsPrograms: {
    contactsProgramsTitle: 'Liste des contacts par programmes',
    colonneDiffuseur: 'Nom diffuseur',
    colonneTotal: 'Total général',
    accessDenied: 'Cette synthèse est réservée aux promoteurs immobiliers disposant du Contact Manager.',
  }
}
